export default {
    // 省
    province_list: {
        '010000':'北京',
        '020000':'天津',
        '030000':'河北省',
        '040000':'山西省',
        '050000':'内蒙古自治区',
        '060000':'辽宁省',
        '070000':'吉林省',
        '080000':'黑龙江省',
        '090000':'上海',
        '100000':'江苏省',
        '110000':'浙江省',
        '120000':'安徽省',
        '130000':'福建省',
        '140000':'江西省',
        '150000':'山东省',
        '160000':'河南省',
        '170000':'湖北省',
        '180000':'湖南省',
        '190000':'广东省',
        '200000':'广西壮族自治区',
        '210000':'海南省',
        '220000':'重庆',
        '230000':'四川省',
        '240000':'贵州省',
        '250000':'云南省',
        '260000':'西藏自治区',
        '270000':'陕西省',
        '280000':'甘肃省',
        '290000':'青海省',
        '300000':'宁夏回族自治区',
        '310000':'新疆维吾尔自治区',
        '330000':'香港特别行政区',
        '340000':'台湾省',
        '350000':'澳门特别行政区',
    },
    // 市
    city_list: {
        '010100':'北京市',
        '020200':'天津市',
        '030100':'石家庄市',
        '030200':'唐山市',
        '030300':'秦皇岛市',
        '030400':'邯郸市',
        '030500':'邢台市',
        '030600':'保定市',
        '030700':'张家口市',
        '030800':'承德市',
        '030900':'沧州市',
        '031000':'廊坊市',
        '031100':'衡水市',
        '040100':'太原市',
        '040200':'大同市',
        '040300':'阳泉市',
        '040400':'长治市',
        '040500':'晋城市',
        '040600':'朔州市',
        '040700':'晋中市',
        '040800':'运城市',
        '040900':'忻州市',
        '041000':'临汾市',
        '041100':'吕梁市',
        '050100':'呼和浩特市',
        '050200':'包头市',
        '050300':'乌海市',
        '050400':'赤峰市',
        '050500':'通辽市',
        '050600':'鄂尔多斯市',
        '050700':'呼伦贝尔市',
        '050800':'巴彦淖尔市',
        '050900':'乌兰察布市',
        '051000':'兴安盟',
        '051100':'锡林郭勒盟',
        '051200':'阿拉善盟',
        '060100':'沈阳市',
        '060200':'大连市',
        '060300':'鞍山市',
        '060400':'抚顺市',
        '060500':'本溪市',
        '060600':'丹东市',
        '060700':'锦州市',
        '060800':'营口市',
        '060900':'阜新市',
        '061000':'辽阳市',
        '061100':'盘锦市',
        '061200':'铁岭市',
        '061300':'朝阳市',
        '061400':'葫芦岛市',
        '070100':'长春市',
        '070200':'吉林市',
        '070300':'四平市',
        '070400':'辽源市',
        '070500':'通化市',
        '070600':'白山市',
        '070700':'松原市',
        '070800':'白城市',
        '070900':'延边朝鲜族自治州',
        '080100':'哈尔滨市',
        '080200':'齐齐哈尔市',
        '080300':'鸡西市',
        '080400':'鹤岗市',
        '080500':'双鸭山市',
        '080600':'大庆市',
        '080700':'伊春市',
        '080800':'佳木斯市',
        '080900':'七台河市',
        '081000':'牡丹江市',
        '081100':'黑河市',
        '081200':'绥化市',
        '081300':'大兴安岭地区',
        '090900':'上海市',
        '100100':'南京市',
        '100200':'无锡市',
        '100300':'徐州市',
        '100400':'常州市',
        '100500':'苏州市',
        '100600':'南通市',
        '100700':'连云港市',
        '100800':'淮安市',
        '100900':'盐城市',
        '101000':'扬州市',
        '101100':'镇江市',
        '101200':'泰州市',
        '101300':'宿迁市',
        '110100':'杭州市',
        '110200':'宁波市',
        '110300':'温州市',
        '110400':'嘉兴市',
        '110500':'湖州市',
        '110600':'绍兴市',
        '110700':'金华市',
        '110800':'衢州市',
        '110900':'舟山市',
        '111000':'台州市',
        '111100':'丽水市',
        '120100':'合肥市',
        '120200':'芜湖市',
        '120300':'蚌埠市',
        '120400':'淮南市',
        '120500':'马鞍山市',
        '120600':'淮北市',
        '120700':'铜陵市',
        '120800':'安庆市',
        '120900':'黄山市',
        '121000':'滁州市',
        '121100':'阜阳市',
        '121200':'宿州市',
        '121400':'六安市',
        '121500':'亳州市',
        '121600':'池州市',
        '121700':'宣城市',
        '130100':'福州市',
        '130200':'厦门市',
        '130300':'莆田市',
        '130400':'三明市',
        '130500':'泉州市',
        '130600':'漳州市',
        '130700':'南平市',
        '130800':'龙岩市',
        '130900':'宁德市',
        '140100':'南昌市',
        '140200':'景德镇市',
        '140300':'萍乡市',
        '140400':'九江市',
        '140500':'新余市',
        '140600':'鹰潭市',
        '140700':'赣州市',
        '140800':'吉安市',
        '140900':'宜春市',
        '141000':'抚州市',
        '141100':'上饶市',
        '150100':'济南市',
        '150200':'青岛市',
        '150300':'淄博市',
        '150400':'枣庄市',
        '150500':'东营市',
        '150600':'烟台市',
        '150700':'潍坊市',
        '150800':'济宁市',
        '150900':'泰安市',
        '151000':'威海市',
        '151100':'日照市',
        '151200':'莱芜市',
        '151300':'临沂市',
        '151400':'德州市',
        '151500':'聊城市',
        '151600':'滨州市',
        '151700':'菏泽市',
        '160100':'郑州市',
        '160200':'开封市',
        '160300':'洛阳市',
        '160400':'平顶山市',
        '160500':'安阳市',
        '160600':'鹤壁市',
        '160700':'新乡市',
        '160800':'焦作市',
        '160900':'濮阳市',
        '161000':'许昌市',
        '161100':'漯河市',
        '161200':'三门峡市',
        '161300':'南阳市',
        '161400':'商丘市',
        '161500':'信阳市',
        '161600':'周口市',
        '161700':'驻马店市',
        '161800':'济源市',
        '170100':'武汉市',
        '170200':'黄石市',
        '170300':'十堰市',
        '170400':'宜昌市',
        '170500':'襄阳市',
        '170600':'鄂州市',
        '170700':'荆门市',
        '170800':'孝感市',
        '170900':'荆州市',
        '171000':'黄冈市',
        '171100':'咸宁市',
        '171200':'随州市',
        '171300':'恩施土家族苗族自治州',
        '171500':'仙桃市',
        '171600':'潜江市',
        '171700':'天门市',
        '171800':'神农架林区',
        '180100':'长沙市',
        '180200':'株洲市',
        '180300':'湘潭市',
        '180400':'衡阳市',
        '180500':'邵阳市',
        '180600':'岳阳市',
        '180700':'常德市',
        '180800':'张家界市',
        '180900':'益阳市',
        '181000':'郴州市',
        '181100':'永州市',
        '181200':'怀化市',
        '181300':'娄底市',
        '181400':'湘西土家族苗族自治州',
        '190100':'广州市',
        '190200':'韶关市',
        '190300':'深圳市',
        '190400':'珠海市',
        '190500':'汕头市',
        '190600':'佛山市',
        '190700':'江门市',
        '190800':'湛江市',
        '190900':'茂名市',
        '191000':'肇庆市',
        '191100':'惠州市',
        '191200':'梅州市',
        '191300':'汕尾市',
        '191400':'河源市',
        '191500':'阳江市',
        '191600':'清远市',
        '191700':'潮州市',
        '191800':'揭阳市',
        '191900':'云浮市',
        '192000':'东莞市',
        '192100':'中山市',
        '192200':'东沙群岛',
        '200100':'南宁市',
        '200200':'柳州市',
        '200300':'桂林市',
        '200400':'梧州市',
        '200500':'北海市',
        '200600':'防城港市',
        '200700':'钦州市',
        '200800':'贵港市',
        '200900':'玉林市',
        '201000':'百色市',
        '201100':'贺州市',
        '201200':'河池市',
        '201300':'来宾市',
        '201400':'崇左市',
        '210100':'海口市',
        '210200':'三亚市',
        '210300':'三沙市',
        '210400':'儋州市',
        '210500':'五指山市',
        '210600':'琼海市',
        '210700':'文昌市',
        '210800':'万宁市',
        '210900':'东方市',
        '211000':'定安县',
        '211100':'屯昌县',
        '211200':'澄迈县',
        '211300':'临高县',
        '211400':'白沙黎族自治县',
        '211500':'昌江黎族自治县',
        '211600':'乐东黎族自治县',
        '211700':'陵水黎族自治县',
        '211800':'保亭黎族苗族自治县',
        '211900':'琼中黎族苗族自治县',
        '222200':'重庆市',
        '230100':'成都市',
        '230200':'自贡市',
        '230300':'攀枝花市',
        '230400':'泸州市',
        '230500':'德阳市',
        '230600':'绵阳市',
        '230700':'广元市',
        '230800':'遂宁市',
        '230900':'内江市',
        '231000':'乐山市',
        '231100':'南充市',
        '231200':'眉山市',
        '231300':'宜宾市',
        '231400':'广安市',
        '231500':'达州市',
        '231600':'雅安市',
        '231700':'巴中市',
        '231800':'资阳市',
        '231900':'阿坝藏族羌族自治州',
        '232000':'甘孜藏族自治州',
        '232100':'凉山彝族自治州',
        '240100':'贵阳市',
        '240200':'六盘水市',
        '240300':'遵义市',
        '240400':'安顺市',
        '240500':'铜仁市',
        '240600':'黔西南布依族苗族自治州',
        '240700':'毕节市',
        '240800':'黔东南苗族侗族自治州',
        '240900':'黔南布依族苗族自治州',
        '250100':'昆明市',
        '250200':'曲靖市',
        '250300':'玉溪市',
        '250400':'保山市',
        '250500':'昭通市',
        '250600':'丽江市',
        '250700':'普洱市',
        '250800':'临沧市',
        '250900':'楚雄彝族自治州',
        '251000':'红河哈尼族彝族自治州',
        '251100':'文山壮族苗族自治州',
        '251200':'西双版纳傣族自治州',
        '251300':'大理白族自治州',
        '251400':'德宏傣族景颇族自治州',
        '251500':'怒江傈僳族自治州',
        '251600':'迪庆藏族自治州',
        '260100':'拉萨市',
        '260200':'昌都市',
        '260300':'山南市',
        '260400':'日喀则市',
        '260500':'那曲市',
        '260600':'阿里地区',
        '260700':'林芝市',
        '270100':'西安市',
        '270200':'铜川市',
        '270300':'宝鸡市',
        '270400':'咸阳市',
        '270500':'渭南市',
        '270600':'延安市',
        '270700':'汉中市',
        '270800':'榆林市',
        '270900':'安康市',
        '271000':'商洛市',
        '280100':'兰州市',
        '280200':'金昌市',
        '280300':'白银市',
        '280400':'天水市',
        '280500':'武威市',
        '280600':'张掖市',
        '280700':'平凉市',
        '280800':'酒泉市',
        '280900':'庆阳市',
        '281000':'定西市',
        '281100':'陇南市',
        '281200':'临夏回族自治州',
        '281300':'甘南藏族自治州',
        '281400':'嘉峪关市',
        '290100':'西宁市',
        '290200':'海东市',
        '290300':'海北藏族自治州',
        '290400':'黄南藏族自治州',
        '290500':'海南藏族自治州',
        '290600':'果洛藏族自治州',
        '290700':'玉树藏族自治州',
        '290800':'海西蒙古族藏族自治州',
        '300100':'银川市',
        '300200':'石嘴山市',
        '300300':'吴忠市',
        '300400':'固原市',
        '300500':'中卫市',
        '310100':'乌鲁木齐市',
        '310200':'克拉玛依市',
        '310300':'吐鲁番市',
        '310400':'哈密地区',
        '310500':'昌吉回族自治州',
        '310600':'博尔塔拉蒙古自治州',
        '310700':'巴音郭楞蒙古自治州',
        '310800':'阿克苏地区',
        '310900':'克孜勒苏柯尔克孜自治州',
        '311000':'喀什地区',
        '311100':'和田地区',
        '311200':'伊犁哈萨克自治州',
        '311300':'塔城地区',
        '311400':'阿勒泰地区',
        '311600':'石河子市',
        '311700':'阿拉尔市',
        '311800':'图木舒克市',
        '311900':'五家渠市',
        '312000':'北屯市',
        '312100':'铁门关市',
        '312200':'双河市',
        '312300':'可克达拉市',
        '312307':'昆玉市(自治区直辖)',
        '335200':'香港',
        '340100':'台北市',
        '340200':'高雄市',
        '340300':'台南市',
        '340400':'台中市',
        '340500':'金门县',
        '340600':'南投县',
        '340700':'基隆市',
        '340800':'新竹市',
        '340900':'嘉义市',
        '341000':'新北市',
        '341100':'宜兰县',
        '341200':'新竹县',
        '341300':'桃园县',
        '341400':'苗栗县',
        '341500':'彰化县',
        '341600':'嘉义县',
        '341700':'云林县',
        '341800':'屏东县',
        '341900':'台东县',
        '342000':'花莲县',
        '342100':'澎湖县',
        '342200':'连江县',
        '350100':'澳门',
    },
    // 区县
    county_list: {
        '010101':'东城区',
        '010102':'西城区',
        '010106':'丰台区',
        '010107':'石景山区',
        '010108':'海淀区',
        '010109':'门头沟区',
        '010110':'房山区',
        '010111':'通州区',
        '010112':'顺义区',
        '010113':'昌平区',
        '010114':'大兴区',
        '010115':'怀柔区',
        '010116':'平谷区',
        '010119':'朝阳区',
        '010201':'密云区',
        '010202':'延庆区',
        '020203':'河西区',
        '020204':'南开区',
        '020205':'河北区',
        '020206':'红桥区',
        '020210':'东丽区',
        '020211':'西青区',
        '020212':'津南区',
        '020213':'北辰区',
        '020214':'武清区',
        '020215':'宝坻区',
        '020219':'和平区',
        '020220':'河东区',
        '020221':'滨海新区',
        '020301':'宁河区',
        '020302':'静海区',
        '020303':'蓟州区',
        '030105':'井陉矿区',
        '030106':'裕华区',
        '030107':'井陉县',
        '030108':'正定县',
        '030109':'栾城区',
        '030110':'行唐县',
        '030111':'灵寿县',
        '030112':'高邑县',
        '030113':'深泽县',
        '030114':'赞皇县',
        '030115':'无极县',
        '030116':'平山县',
        '030117':'元氏县',
        '030118':'赵县',
        '030119':'辛集市',
        '030120':'藁城区',
        '030121':'晋州市',
        '030122':'新乐市',
        '030123':'鹿泉区',
        '030124':'长安区',
        '030125':'桥西区',
        '030126':'新华区',
        '030201':'路南区',
        '030202':'路北区',
        '030203':'古冶区',
        '030204':'开平区',
        '030205':'丰南区',
        '030206':'丰润区',
        '030207':'滦县',
        '030208':'滦南县',
        '030209':'乐亭县',
        '030210':'迁西县',
        '030211':'玉田县',
        '030213':'遵化市',
        '030214':'迁安市',
        '030215':'曹妃甸区',
        '030301':'海港区',
        '030302':'山海关区',
        '030303':'北戴河区',
        '030304':'青龙满族自治县',
        '030305':'昌黎县',
        '030306':'抚宁区',
        '030307':'卢龙县',
        '030401':'邯山区',
        '030402':'丛台区',
        '030403':'复兴区',
        '030404':'峰峰矿区',
        '030405':'邯郸县',
        '030406':'临漳县',
        '030407':'成安县',
        '030408':'大名县',
        '030409':'涉县',
        '030410':'磁县',
        '030411':'肥乡区',
        '030412':'永年区',
        '030413':'邱县',
        '030414':'鸡泽县',
        '030415':'广平县',
        '030416':'馆陶县',
        '030417':'魏县',
        '030418':'曲周县',
        '030419':'武安市',
        '030503':'邢台县',
        '030504':'临城县',
        '030505':'内丘县',
        '030506':'柏乡县',
        '030507':'隆尧县',
        '030508':'任县',
        '030509':'南和县',
        '030510':'宁晋县',
        '030511':'巨鹿县',
        '030512':'新河县',
        '030513':'广宗县',
        '030514':'平乡县',
        '030515':'威县',
        '030516':'清河县',
        '030517':'临西县',
        '030518':'南宫市',
        '030519':'沙河市',
        '030520':'桥东区',
        '030521':'桥西区',
        '030604':'满城区',
        '030605':'清苑区',
        '030606':'涞水县',
        '030607':'阜平县',
        '030608':'徐水区',
        '030609':'定兴县',
        '030610':'唐县',
        '030611':'高阳县',
        '030612':'容城县',
        '030613':'涞源县',
        '030614':'望都县',
        '030615':'安新县',
        '030616':'易县',
        '030617':'曲阳县',
        '030618':'蠡县',
        '030619':'顺平县',
        '030620':'博野县',
        '030621':'雄县',
        '030622':'涿州市',
        '030623':'定州市',
        '030624':'安国市',
        '030625':'高碑店市',
        '030626':'竞秀区',
        '030627':'莲池区',
        '030703':'宣化区',
        '030704':'下花园区',
        '030705':'宣化县',
        '030706':'张北县',
        '030707':'康保县',
        '030708':'沽源县',
        '030709':'尚义县',
        '030710':'蔚县',
        '030711':'阳原县',
        '030712':'怀安县',
        '030713':'万全区',
        '030714':'怀来县',
        '030715':'涿鹿县',
        '030716':'赤城县',
        '030717':'崇礼区',
        '030718':'桥东区',
        '030719':'桥西区',
        '030802':'双滦区',
        '030803':'鹰手营子矿区',
        '030804':'承德县',
        '030805':'兴隆县',
        '030806':'平泉市',
        '030807':'滦平县',
        '030808':'隆化县',
        '030809':'丰宁满族自治县',
        '030810':'宽城满族自治县',
        '030811':'围场满族蒙古族自治县',
        '030812':'双桥区',
        '030902':'运河区',
        '030903':'沧县',
        '030904':'青县',
        '030905':'东光县',
        '030906':'海兴县',
        '030907':'盐山县',
        '030908':'肃宁县',
        '030909':'南皮县',
        '030910':'吴桥县',
        '030911':'献县',
        '030912':'孟村回族自治县',
        '030913':'泊头市',
        '030914':'任丘市',
        '030915':'黄骅市',
        '030916':'河间市',
        '030917':'新华区',
        '031001':'安次区',
        '031002':'广阳区',
        '031003':'固安县',
        '031004':'永清县',
        '031005':'香河县',
        '031006':'大城县',
        '031007':'文安县',
        '031008':'大厂回族自治县',
        '031009':'霸州市',
        '031010':'三河市',
        '031101':'桃城区',
        '031102':'枣强县',
        '031103':'武邑县',
        '031104':'武强县',
        '031105':'饶阳县',
        '031106':'安平县',
        '031107':'故城县',
        '031108':'景县',
        '031109':'阜城县',
        '031110':'冀州区',
        '031111':'深州市',
        '040101':'小店区',
        '040102':'迎泽区',
        '040103':'杏花岭区',
        '040104':'尖草坪区',
        '040105':'万柏林区',
        '040106':'晋源区',
        '040107':'清徐县',
        '040108':'阳曲县',
        '040109':'娄烦县',
        '040110':'古交市',
        '040203':'南郊区',
        '040204':'新荣区',
        '040205':'阳高县',
        '040206':'天镇县',
        '040207':'广灵县',
        '040208':'灵丘县',
        '040209':'浑源县',
        '040210':'左云县',
        '040211':'大同县',
        '040212':'城区',
        '040213':'矿区',
        '040304':'平定县',
        '040305':'盂县',
        '040306':'城区',
        '040307':'矿区',
        '040308':'郊区',
        '040403':'长治县',
        '040404':'襄垣县',
        '040405':'屯留县',
        '040406':'平顺县',
        '040407':'黎城县',
        '040408':'壶关县',
        '040409':'长子县',
        '040410':'武乡县',
        '040411':'沁县',
        '040412':'沁源县',
        '040413':'潞城市',
        '040414':'城区',
        '040415':'郊区',
        '040502':'沁水县',
        '040503':'阳城县',
        '040504':'陵川县',
        '040505':'泽州县',
        '040506':'高平市',
        '040507':'城区',
        '040601':'朔城区',
        '040602':'平鲁区',
        '040603':'山阴县',
        '040604':'应县',
        '040605':'右玉县',
        '040606':'怀仁县',
        '040701':'榆次区',
        '040702':'榆社县',
        '040703':'左权县',
        '040704':'和顺县',
        '040705':'昔阳县',
        '040706':'寿阳县',
        '040707':'太谷县',
        '040708':'祁县',
        '040709':'平遥县',
        '040710':'灵石县',
        '040711':'介休市',
        '040801':'盐湖区',
        '040802':'临猗县',
        '040803':'万荣县',
        '040804':'闻喜县',
        '040805':'稷山县',
        '040806':'新绛县',
        '040807':'绛县',
        '040808':'垣曲县',
        '040809':'夏县',
        '040810':'平陆县',
        '040811':'芮城县',
        '040812':'永济市',
        '040813':'河津市',
        '040901':'忻府区',
        '040902':'定襄县',
        '040903':'五台县',
        '040904':'代县',
        '040905':'繁峙县',
        '040906':'宁武县',
        '040907':'静乐县',
        '040908':'神池县',
        '040909':'五寨县',
        '040910':'岢岚县',
        '040911':'河曲县',
        '040912':'保德县',
        '040913':'偏关县',
        '040914':'原平市',
        '041001':'尧都区',
        '041002':'曲沃县',
        '041003':'翼城县',
        '041004':'襄汾县',
        '041005':'洪洞县',
        '041006':'古县',
        '041007':'安泽县',
        '041008':'浮山县',
        '041009':'吉县',
        '041010':'乡宁县',
        '041011':'大宁县',
        '041012':'隰县',
        '041013':'永和县',
        '041014':'蒲县',
        '041015':'汾西县',
        '041016':'侯马市',
        '041017':'霍州市',
        '041101':'离石区',
        '041102':'文水县',
        '041103':'交城县',
        '041104':'兴县',
        '041105':'临县',
        '041106':'柳林县',
        '041107':'石楼县',
        '041108':'岚县',
        '041109':'方山县',
        '041110':'中阳县',
        '041111':'交口县',
        '041112':'孝义市',
        '041113':'汾阳市',
        '050102':'回民区',
        '050103':'玉泉区',
        '050104':'土默特左旗',
        '050105':'托克托县',
        '050106':'和林格尔县',
        '050107':'清水河县',
        '050108':'武川县',
        '050109':'新城区',
        '050110':'赛罕区',
        '050112':'如意开发区',
        '050201':'东河区',
        '050205':'土默特右旗',
        '050206':'固阳县',
        '050207':'达尔罕茂明安联合旗',
        '050208':'昆都仑区',
        '050209':'青山区',
        '050210':'石拐区',
        '050211':'白云鄂博矿区',
        '050212':'九原区',
        '050301':'海勃湾区',
        '050302':'海南区',
        '050303':'乌达区',
        '050401':'红山区',
        '050402':'元宝山区',
        '050403':'松山区',
        '050404':'阿鲁科尔沁旗',
        '050405':'巴林左旗',
        '050406':'巴林右旗',
        '050407':'林西县',
        '050408':'克什克腾旗',
        '050409':'翁牛特旗',
        '050410':'喀喇沁旗',
        '050411':'宁城县',
        '050412':'敖汉旗',
        '050501':'科尔沁区',
        '050502':'科尔沁左翼中旗',
        '050503':'科尔沁左翼后旗',
        '050504':'开鲁县',
        '050505':'库伦旗',
        '050506':'奈曼旗',
        '050507':'扎鲁特旗',
        '050508':'霍林郭勒市',
        '050601':'东胜区',
        '050602':'达拉特旗',
        '050603':'准格尔旗',
        '050604':'鄂托克前旗',
        '050605':'鄂托克旗',
        '050606':'杭锦旗',
        '050607':'乌审旗',
        '050608':'伊金霍洛旗',
        '050609':'康巴什区',
        '050701':'海拉尔区',
        '050702':'阿荣旗',
        '050703':'莫力达瓦达斡尔族自治旗',
        '050704':'鄂伦春自治旗',
        '050705':'鄂温克族自治旗',
        '050706':'陈巴尔虎旗',
        '050707':'新巴尔虎左旗',
        '050708':'新巴尔虎右旗',
        '050709':'满洲里市',
        '050710':'牙克石市',
        '050711':'扎兰屯市',
        '050712':'额尔古纳市',
        '050713':'根河市',
        '050714':'扎赉诺尔区',
        '050801':'临河区',
        '050802':'五原县',
        '050803':'磴口县',
        '050804':'乌拉特前旗',
        '050805':'乌拉特中旗',
        '050806':'乌拉特后旗',
        '050807':'杭锦后旗',
        '050901':'集宁区',
        '050902':'卓资县',
        '050903':'化德县',
        '050904':'商都县',
        '050905':'兴和县',
        '050906':'凉城县',
        '050907':'察哈尔右翼前旗',
        '050908':'察哈尔右翼中旗',
        '050909':'察哈尔右翼后旗',
        '050910':'四子王旗',
        '050911':'丰镇市',
        '051001':'乌兰浩特市',
        '051002':'阿尔山市',
        '051003':'科尔沁右翼前旗',
        '051004':'科尔沁右翼中旗',
        '051005':'扎赉特旗',
        '051006':'突泉县',
        '051101':'二连浩特市',
        '051102':'锡林浩特市',
        '051103':'阿巴嘎旗',
        '051104':'苏尼特左旗',
        '051105':'苏尼特右旗',
        '051106':'东乌珠穆沁旗',
        '051107':'西乌珠穆沁旗',
        '051108':'太仆寺旗',
        '051109':'镶黄旗',
        '051110':'正镶白旗',
        '051111':'正蓝旗',
        '051112':'多伦县',
        '051201':'阿拉善左旗',
        '051202':'阿拉善右旗',
        '051203':'额济纳旗',
        '060102':'沈河区',
        '060103':'大东区',
        '060104':'皇姑区',
        '060106':'苏家屯区',
        '060108':'沈北新区',
        '060109':'于洪区',
        '060110':'辽中区',
        '060111':'康平县',
        '060112':'法库县',
        '060113':'新民市',
        '060114':'和平区',
        '060115':'铁西区',
        '060116':'浑南区',
        '060201':'中山区',
        '060202':'西岗区',
        '060203':'沙河口区',
        '060204':'甘井子区',
        '060205':'旅顺口区',
        '060206':'金州区',
        '060207':'长海县',
        '060208':'瓦房店市',
        '060209':'普兰店区',
        '060210':'庄河市',
        '060303':'立山区',
        '060304':'千山区',
        '060305':'台安县',
        '060306':'岫岩满族自治县',
        '060307':'海城市',
        '060308':'铁东区',
        '060309':'铁西区',
        '060401':'新抚区',
        '060402':'东洲区',
        '060403':'望花区',
        '060404':'顺城区',
        '060405':'抚顺县',
        '060406':'新宾满族自治县',
        '060407':'清原满族自治县',
        '060501':'平山区',
        '060502':'溪湖区',
        '060503':'明山区',
        '060504':'南芬区',
        '060505':'本溪满族自治县',
        '060506':'桓仁满族自治县',
        '060601':'元宝区',
        '060602':'振兴区',
        '060603':'振安区',
        '060604':'宽甸满族自治县',
        '060605':'东港市',
        '060606':'凤城市',
        '060701':'古塔区',
        '060702':'凌河区',
        '060703':'太和区',
        '060704':'黑山县',
        '060705':'义县',
        '060706':'凌海市',
        '060707':'北镇市',
        '060801':'站前区',
        '060802':'西市区',
        '060803':'鲅鱼圈区',
        '060804':'老边区',
        '060805':'盖州市',
        '060806':'大石桥市',
        '060902':'新邱区',
        '060903':'太平区',
        '060904':'清河门区',
        '060905':'细河区',
        '060906':'阜新蒙古族自治县',
        '060907':'彰武县',
        '060908':'海州区',
        '061001':'白塔区',
        '061002':'文圣区',
        '061003':'宏伟区',
        '061004':'弓长岭区',
        '061005':'太子河区',
        '061006':'辽阳县',
        '061007':'灯塔市',
        '061101':'双台子区',
        '061102':'兴隆台区',
        '061103':'大洼区',
        '061104':'盘山县',
        '061201':'银州区',
        '061203':'铁岭县',
        '061204':'西丰县',
        '061205':'昌图县',
        '061206':'调兵山市',
        '061207':'开原市',
        '061208':'清河区',
        '061301':'双塔区',
        '061302':'龙城区',
        '061303':'朝阳县',
        '061304':'建平县',
        '061305':'喀喇沁左翼蒙古族自治县',
        '061306':'北票市',
        '061307':'凌源市',
        '061401':'连山区',
        '061402':'龙港区',
        '061403':'南票区',
        '061404':'绥中县',
        '061405':'建昌县',
        '061406':'兴城市',
        '070101':'南关区',
        '070102':'宽城区',
        '070104':'二道区',
        '070105':'绿园区',
        '070106':'双阳区',
        '070107':'农安县',
        '070108':'九台区',
        '070109':'榆树市',
        '070110':'德惠市',
        '070111':'朝阳区',
        '070116':'长春新区',
        '070201':'昌邑区',
        '070202':'龙潭区',
        '070203':'船营区',
        '070204':'丰满区',
        '070205':'永吉县',
        '070206':'蛟河市',
        '070207':'桦甸市',
        '070208':'舒兰市',
        '070209':'磐石市',
        '070303':'梨树县',
        '070304':'伊通满族自治县',
        '070305':'公主岭市',
        '070306':'双辽市',
        '070307':'铁西区',
        '070308':'铁东区',
        '070401':'龙山区',
        '070403':'东丰县',
        '070404':'东辽县',
        '070405':'西安区',
        '070501':'东昌区',
        '070502':'二道江区',
        '070503':'通化县',
        '070504':'辉南县',
        '070505':'柳河县',
        '070506':'梅河口市',
        '070507':'集安市',
        '070602':'江源区',
        '070603':'抚松县',
        '070604':'靖宇县',
        '070605':'长白朝鲜族自治县',
        '070606':'临江市',
        '070607':'浑江区',
        '070701':'宁江区',
        '070702':'前郭尔罗斯蒙古族自治县',
        '070703':'长岭县',
        '070704':'乾安县',
        '070705':'扶余市',
        '070801':'洮北区',
        '070802':'镇赉县',
        '070803':'通榆县',
        '070804':'洮南市',
        '070805':'大安市',
        '070901':'延吉市',
        '070902':'图们市',
        '070903':'敦化市',
        '070904':'珲春市',
        '070905':'龙井市',
        '070906':'和龙市',
        '070907':'汪清县',
        '070908':'安图县',
        '080101':'道里区',
        '080102':'南岗区',
        '080103':'道外区',
        '080105':'平房区',
        '080106':'松北区',
        '080107':'香坊区',
        '080108':'呼兰区',
        '080109':'阿城区',
        '080110':'依兰县',
        '080111':'方正县',
        '080112':'宾县',
        '080113':'巴彦县',
        '080114':'木兰县',
        '080115':'通河县',
        '080116':'延寿县',
        '080117':'双城区',
        '080118':'尚志市',
        '080119':'五常市',
        '080201':'龙沙区',
        '080202':'建华区',
        '080203':'铁锋区',
        '080204':'昂昂溪区',
        '080205':'富拉尔基区',
        '080206':'碾子山区',
        '080207':'梅里斯达斡尔族区',
        '080208':'龙江县',
        '080209':'依安县',
        '080210':'泰来县',
        '080211':'甘南县',
        '080212':'富裕县',
        '080213':'克山县',
        '080214':'克东县',
        '080215':'拜泉县',
        '080216':'讷河市',
        '080301':'鸡冠区',
        '080302':'恒山区',
        '080303':'滴道区',
        '080304':'梨树区',
        '080305':'城子河区',
        '080306':'麻山区',
        '080307':'鸡东县',
        '080308':'虎林市',
        '080309':'密山市',
        '080402':'工农区',
        '080404':'兴安区',
        '080405':'东山区',
        '080406':'兴山区',
        '080407':'萝北县',
        '080408':'绥滨县',
        '080409':'向阳区',
        '080410':'南山区',
        '080501':'尖山区',
        '080502':'岭东区',
        '080503':'四方台区',
        '080505':'集贤县',
        '080506':'友谊县',
        '080507':'宝清县',
        '080508':'饶河县',
        '080509':'宝山区',
        '080601':'萨尔图区',
        '080602':'龙凤区',
        '080603':'让胡路区',
        '080604':'红岗区',
        '080605':'大同区',
        '080606':'肇州县',
        '080607':'肇源县',
        '080608':'林甸县',
        '080609':'杜尔伯特蒙古族自治县',
        '080701':'伊春区',
        '080702':'南岔区',
        '080703':'友好区',
        '080704':'西林区',
        '080705':'翠峦区',
        '080706':'新青区',
        '080707':'美溪区',
        '080708':'金山屯区',
        '080709':'五营区',
        '080710':'乌马河区',
        '080711':'汤旺河区',
        '080712':'带岭区',
        '080713':'乌伊岭区',
        '080714':'红星区',
        '080715':'上甘岭区',
        '080716':'嘉荫县',
        '080717':'铁力市',
        '080802':'前进区',
        '080803':'东风区',
        '080804':'桦南县',
        '080805':'桦川县',
        '080806':'汤原县',
        '080807':'抚远市',
        '080808':'同江市',
        '080809':'富锦市',
        '080810':'向阳区',
        '080811':'郊区',
        '080901':'新兴区',
        '080902':'桃山区',
        '080903':'茄子河区',
        '080904':'勃利县',
        '081001':'东安区',
        '081002':'阳明区',
        '081003':'爱民区',
        '081005':'东宁市',
        '081006':'林口县',
        '081007':'绥芬河市',
        '081008':'海林市',
        '081009':'宁安市',
        '081010':'穆棱市',
        '081011':'西安区',
        '081101':'爱辉区',
        '081102':'嫩江县',
        '081103':'逊克县',
        '081104':'孙吴县',
        '081105':'北安市',
        '081106':'五大连池市',
        '081201':'北林区',
        '081202':'望奎县',
        '081203':'兰西县',
        '081204':'青冈县',
        '081205':'庆安县',
        '081206':'明水县',
        '081207':'绥棱县',
        '081208':'安达市',
        '081209':'肇东市',
        '081210':'海伦市',
        '081301':'加格达奇区',
        '081302':'呼玛县',
        '081303':'塔河县',
        '081304':'漠河县',
        '090901':'黄浦区',
        '090903':'徐汇区',
        '090904':'长宁区',
        '090905':'静安区',
        '090907':'闸北区',
        '090908':'虹口区',
        '090909':'杨浦区',
        '090910':'闵行区',
        '090912':'嘉定区',
        '090913':'浦东新区',
        '090914':'金山区',
        '090915':'松江区',
        '090916':'青浦区',
        '090918':'奉贤区',
        '090920':'普陀区',
        '090921':'宝山区',
        '091001':'崇明区',
        '100101':'玄武区',
        '100103':'秦淮区',
        '100104':'建邺区',
        '100107':'浦口区',
        '100108':'栖霞区',
        '100109':'雨花台区',
        '100110':'江宁区',
        '100111':'六合区',
        '100112':'溧水区',
        '100113':'高淳区',
        '100114':'鼓楼区',
        '100201':'崇安区',
        '100202':'南长区',
        '100203':'北塘区',
        '100204':'锡山区',
        '100205':'惠山区',
        '100206':'江阴市',
        '100207':'宜兴市',
        '100208':'滨湖区',
        '100209':'梁溪区',
        '100210':'新吴区',
        '100302':'云龙区',
        '100304':'贾汪区',
        '100305':'泉山区',
        '100306':'丰县',
        '100307':'沛县',
        '100308':'铜山区',
        '100309':'睢宁县',
        '100310':'新沂市',
        '100311':'邳州市',
        '100312':'鼓楼区',
        '100401':'天宁区',
        '100402':'钟楼区',
        '100404':'武进区',
        '100405':'溧阳市',
        '100406':'金坛区',
        '100407':'新北区',
        '100504':'虎丘区',
        '100505':'吴中区',
        '100506':'相城区',
        '100507':'常熟市',
        '100508':'张家港市',
        '100509':'昆山市',
        '100510':'吴江区',
        '100511':'太仓市',
        '100512':'姑苏区',
        '100601':'崇川区',
        '100602':'港闸区',
        '100603':'海安县',
        '100604':'如东县',
        '100605':'启东市',
        '100606':'如皋市',
        '100607':'通州区',
        '100608':'海门市',
        '100701':'连云区',
        '100704':'赣榆区',
        '100705':'东海县',
        '100706':'灌云县',
        '100707':'灌南县',
        '100708':'海州区',
        '100803':'淮阴区',
        '100804':'清浦区',
        '100805':'涟水县',
        '100806':'洪泽区',
        '100807':'盱眙县',
        '100808':'金湖县',
        '100809':'清河区',
        '100810':'淮安区',
        '100811':'清江浦区',
        '100901':'盐都区',
        '100902':'响水县',
        '100903':'滨海县',
        '100904':'阜宁县',
        '100905':'射阳县',
        '100906':'建湖县',
        '100907':'东台市',
        '100908':'大丰区',
        '100909':'亭湖区',
        '101001':'广陵区',
        '101002':'邗江区',
        '101003':'宝应县',
        '101004':'仪征市',
        '101005':'高邮市',
        '101006':'江都区',
        '101101':'京口区',
        '101102':'润州区',
        '101103':'丹徒区',
        '101104':'丹阳市',
        '101105':'扬中市',
        '101106':'句容市',
        '101201':'海陵区',
        '101202':'高港区',
        '101203':'兴化市',
        '101204':'靖江市',
        '101205':'泰兴市',
        '101206':'姜堰区',
        '101301':'宿城区',
        '101302':'宿豫区',
        '101303':'沭阳县',
        '101304':'泗阳县',
        '101305':'泗洪县',
        '110101':'上城区',
        '110102':'下城区',
        '110103':'江干区',
        '110104':'拱墅区',
        '110106':'滨江区',
        '110107':'萧山区',
        '110108':'余杭区',
        '110109':'桐庐县',
        '110110':'淳安县',
        '110111':'建德市',
        '110112':'富阳区',
        '110113':'临安区',
        '110114':'西湖区',
        '110201':'海曙区',
        '110202':'江东区',
        '110204':'北仑区',
        '110205':'镇海区',
        '110206':'鄞州区',
        '110207':'象山县',
        '110208':'宁海县',
        '110209':'余姚市',
        '110210':'慈溪市',
        '110211':'奉化区',
        '110212':'江北区',
        '110301':'鹿城区',
        '110302':'龙湾区',
        '110303':'瓯海区',
        '110304':'洞头区',
        '110305':'永嘉县',
        '110306':'平阳县',
        '110307':'苍南县',
        '110308':'文成县',
        '110309':'泰顺县',
        '110310':'瑞安市',
        '110311':'乐清市',
        '110402':'嘉善县',
        '110403':'海盐县',
        '110404':'海宁市',
        '110405':'平湖市',
        '110406':'桐乡市',
        '110407':'南湖区',
        '110408':'秀洲区',
        '110501':'吴兴区',
        '110502':'南浔区',
        '110503':'德清县',
        '110504':'长兴县',
        '110505':'安吉县',
        '110601':'越城区',
        '110603':'新昌县',
        '110604':'诸暨市',
        '110605':'上虞区',
        '110606':'嵊州市',
        '110607':'柯桥区',
        '110701':'婺城区',
        '110702':'金东区',
        '110703':'武义县',
        '110704':'浦江县',
        '110705':'磐安县',
        '110706':'兰溪市',
        '110707':'义乌市',
        '110708':'东阳市',
        '110709':'永康市',
        '110801':'柯城区',
        '110802':'衢江区',
        '110803':'常山县',
        '110804':'开化县',
        '110805':'龙游县',
        '110806':'江山市',
        '110901':'定海区',
        '110903':'岱山县',
        '110904':'嵊泗县',
        '110905':'普陀区',
        '111001':'椒江区',
        '111002':'黄岩区',
        '111003':'路桥区',
        '111004':'玉环县',
        '111005':'三门县',
        '111006':'天台县',
        '111007':'仙居县',
        '111008':'温岭市',
        '111009':'临海市',
        '111010':'玉环市',
        '111101':'莲都区',
        '111102':'青田县',
        '111103':'缙云县',
        '111104':'遂昌县',
        '111105':'松阳县',
        '111106':'云和县',
        '111107':'庆元县',
        '111108':'景宁畲族自治县',
        '111109':'龙泉市',
        '1120805':'枞阳县',
        '120101':'瑶海区',
        '120102':'庐阳区',
        '120103':'蜀山区',
        '120104':'包河区',
        '120105':'长丰县',
        '120106':'肥西县',
        '120107':'肥东县',
        '120108':'庐江县',
        '120109':'巢湖市',
        '120201':'镜湖区',
        '120202':'弋江区',
        '120203':'鸠江区',
        '120204':'三山区',
        '120205':'芜湖县',
        '120206':'繁昌县',
        '120207':'南陵县',
        '120208':'无为县',
        '120301':'龙子湖区',
        '120302':'蚌山区',
        '120303':'禹会区',
        '120304':'淮上区',
        '120305':'怀远县',
        '120306':'五河县',
        '120307':'固镇县',
        '120401':'大通区',
        '120402':'田家庵区',
        '120403':'谢家集区',
        '120404':'八公山区',
        '120405':'潘集区',
        '120406':'凤台县',
        '120502':'花山区',
        '120503':'雨山区',
        '120504':'当涂县',
        '120505':'博望区',
        '120506':'含山县',
        '120507':'和县',
        '120601':'杜集区',
        '120602':'相山区',
        '120603':'烈山区',
        '120604':'濉溪县',
        '120701':'铜官山区',
        '120702':'狮子山区',
        '120703':'义安区',
        '120704':'铜陵县',
        '120705':'郊区',
        '120706':'铜官区',
        '120801':'迎江区',
        '120802':'大观区',
        '120804':'怀宁县',
        '120805':'枞阳县',
        '120806':'潜山县',
        '120807':'太湖县',
        '120808':'宿松县',
        '120809':'望江县',
        '120810':'岳西县',
        '120811':'桐城市',
        '120812':'宜秀区',
        '120901':'屯溪区',
        '120902':'黄山区',
        '120903':'徽州区',
        '120904':'歙县',
        '120905':'休宁县',
        '120906':'黟县',
        '120907':'祁门县',
        '121001':'琅琊区',
        '121002':'南谯区',
        '121003':'来安县',
        '121004':'全椒县',
        '121005':'定远县',
        '121006':'凤阳县',
        '121007':'天长市',
        '121008':'明光市',
        '121101':'颍州区',
        '121102':'颍东区',
        '121103':'颍泉区',
        '121104':'临泉县',
        '121105':'太和县',
        '121106':'阜南县',
        '121107':'颍上县',
        '121108':'界首市',
        '121202':'砀山县',
        '121203':'萧县',
        '121204':'灵璧县',
        '121205':'泗县',
        '121206':'埇桥区',
        '121401':'金安区',
        '121402':'裕安区',
        '121403':'寿县',
        '121404':'霍邱县',
        '121405':'舒城县',
        '121406':'金寨县',
        '121407':'霍山县',
        '121501':'谯城区',
        '121502':'涡阳县',
        '121503':'蒙城县',
        '121504':'利辛县',
        '121601':'贵池区',
        '121602':'东至县',
        '121603':'石台县',
        '121604':'青阳县',
        '121701':'宣州区',
        '121702':'郎溪县',
        '121703':'广德县',
        '121704':'泾县',
        '121705':'绩溪县',
        '121706':'旌德县',
        '121707':'宁国市',
        '130102':'台江区',
        '130103':'仓山区',
        '130104':'马尾区',
        '130105':'晋安区',
        '130106':'闽侯县',
        '130107':'连江县',
        '130108':'罗源县',
        '130109':'闽清县',
        '130110':'永泰县',
        '130111':'平潭县',
        '130112':'福清市',
        '130113':'长乐区',
        '130114':'鼓楼区',
        '130201':'思明区',
        '130202':'海沧区',
        '130203':'湖里区',
        '130204':'集美区',
        '130205':'同安区',
        '130206':'翔安区',
        '130301':'城厢区',
        '130302':'涵江区',
        '130303':'荔城区',
        '130304':'秀屿区',
        '130305':'仙游县',
        '130401':'梅列区',
        '130402':'三元区',
        '130403':'明溪县',
        '130404':'清流县',
        '130405':'宁化县',
        '130406':'大田县',
        '130407':'尤溪县',
        '130408':'沙县',
        '130409':'将乐县',
        '130410':'泰宁县',
        '130411':'建宁县',
        '130412':'永安市',
        '130501':'鲤城区',
        '130502':'丰泽区',
        '130503':'洛江区',
        '130504':'泉港区',
        '130505':'惠安县',
        '130506':'安溪县',
        '130507':'永春县',
        '130508':'德化县',
        '130509':'金门县',
        '130510':'石狮市',
        '130511':'晋江市',
        '130512':'南安市',
        '130601':'芗城区',
        '130602':'龙文区',
        '130603':'云霄县',
        '130604':'漳浦县',
        '130605':'诏安县',
        '130606':'长泰县',
        '130607':'东山县',
        '130608':'南靖县',
        '130609':'平和县',
        '130610':'华安县',
        '130611':'龙海市',
        '130701':'延平区',
        '130702':'顺昌县',
        '130703':'浦城县',
        '130704':'光泽县',
        '130705':'松溪县',
        '130706':'政和县',
        '130707':'邵武市',
        '130708':'武夷山市',
        '130709':'建瓯市',
        '130710':'建阳区',
        '130801':'新罗区',
        '130802':'长汀县',
        '130803':'永定区',
        '130804':'上杭县',
        '130805':'武平县',
        '130806':'连城县',
        '130807':'漳平市',
        '130901':'蕉城区',
        '130902':'霞浦县',
        '130903':'古田县',
        '130904':'屏南县',
        '130905':'寿宁县',
        '130906':'周宁县',
        '130907':'柘荣县',
        '130908':'福安市',
        '130909':'福鼎市',
        '140101':'东湖区',
        '140103':'青云谱区',
        '140104':'湾里区',
        '140105':'南昌县',
        '140106':'新建区',
        '140107':'安义县',
        '140108':'进贤县',
        '140109':'西湖区',
        '140110':'青山湖区',
        '140201':'昌江区',
        '140202':'珠山区',
        '140203':'浮梁县',
        '140204':'乐平市',
        '140301':'安源区',
        '140302':'湘东区',
        '140303':'莲花县',
        '140304':'上栗县',
        '140305':'芦溪县',
        '140401':'庐山市',
        '140402':'浔阳区',
        '140403':'柴桑区',
        '140404':'武宁县',
        '140405':'修水县',
        '140406':'永修县',
        '140407':'德安县',
        '140408':'星子县',
        '140409':'都昌县',
        '140410':'湖口县',
        '140411':'彭泽县',
        '140412':'瑞昌市',
        '140413':'共青城市',
        '140414':'濂溪区',
        '140415':'赣江新区',
        '140501':'渝水区',
        '140502':'分宜县',
        '140601':'月湖区',
        '140602':'余江县',
        '140603':'贵溪市',
        '140701':'章贡区',
        '140702':'赣县区',
        '140703':'信丰县',
        '140704':'大余县',
        '140705':'上犹县',
        '140706':'崇义县',
        '140707':'安远县',
        '140708':'龙南县',
        '140709':'定南县',
        '140710':'全南县',
        '140711':'宁都县',
        '140712':'于都县',
        '140713':'兴国县',
        '140714':'会昌县',
        '140715':'寻乌县',
        '140716':'石城县',
        '140717':'瑞金市',
        '140718':'南康区',
        '140801':'吉州区',
        '140802':'青原区',
        '140803':'吉安县',
        '140804':'吉水县',
        '140805':'峡江县',
        '140806':'新干县',
        '140807':'永丰县',
        '140808':'泰和县',
        '140809':'遂川县',
        '140810':'万安县',
        '140811':'安福县',
        '140812':'永新县',
        '140813':'井冈山市',
        '140901':'袁州区',
        '140902':'奉新县',
        '140903':'万载县',
        '140904':'上高县',
        '140905':'宜丰县',
        '140906':'靖安县',
        '140907':'铜鼓县',
        '140908':'丰城市',
        '140909':'樟树市',
        '140910':'高安市',
        '141001':'临川区',
        '141002':'南城县',
        '141003':'黎川县',
        '141004':'南丰县',
        '141005':'崇仁县',
        '141006':'乐安县',
        '141007':'宜黄县',
        '141008':'金溪县',
        '141009':'资溪县',
        '141010':'东乡区',
        '141011':'广昌县',
        '141101':'信州区',
        '141102':'上饶县',
        '141103':'广丰区',
        '141104':'玉山县',
        '141105':'铅山县',
        '141106':'横峰县',
        '141107':'弋阳县',
        '141108':'余干县',
        '141109':'鄱阳县',
        '141110':'万年县',
        '141111':'婺源县',
        '141112':'德兴市',
        '150101':'历下区',
        '150103':'槐荫区',
        '150104':'天桥区',
        '150105':'历城区',
        '150106':'长清区',
        '150107':'平阴县',
        '150108':'济阳县',
        '150109':'商河县',
        '150110':'章丘区',
        '150111':'市中区',
        '150201':'市南区',
        '150202':'市北区',
        '150204':'黄岛区',
        '150205':'崂山区',
        '150206':'李沧区',
        '150207':'城阳区',
        '150208':'胶州市',
        '150209':'即墨区',
        '150210':'平度市',
        '150212':'莱西市',
        '150301':'淄川区',
        '150302':'张店区',
        '150303':'博山区',
        '150304':'临淄区',
        '150305':'周村区',
        '150306':'桓台县',
        '150307':'高青县',
        '150308':'沂源县',
        '150402':'薛城区',
        '150403':'峄城区',
        '150404':'台儿庄区',
        '150405':'山亭区',
        '150406':'滕州市',
        '150407':'市中区',
        '150501':'东营区',
        '150502':'河口区',
        '150503':'垦利区',
        '150504':'利津县',
        '150505':'广饶县',
        '150601':'芝罘区',
        '150602':'福山区',
        '150603':'牟平区',
        '150604':'莱山区',
        '150605':'长岛县',
        '150606':'龙口市',
        '150607':'莱阳市',
        '150608':'莱州市',
        '150609':'蓬莱市',
        '150610':'招远市',
        '150611':'栖霞市',
        '150612':'海阳市',
        '150701':'潍城区',
        '150702':'寒亭区',
        '150703':'坊子区',
        '150704':'奎文区',
        '150705':'临朐县',
        '150706':'昌乐县',
        '150707':'青州市',
        '150708':'诸城市',
        '150709':'寿光市',
        '150710':'安丘市',
        '150711':'高密市',
        '150712':'昌邑市',
        '150802':'任城区',
        '150803':'微山县',
        '150804':'鱼台县',
        '150805':'金乡县',
        '150806':'嘉祥县',
        '150807':'汶上县',
        '150808':'泗水县',
        '150809':'梁山县',
        '150810':'曲阜市',
        '150811':'兖州区',
        '150812':'邹城市',
        '150901':'泰山区',
        '150902':'岱岳区',
        '150903':'宁阳县',
        '150904':'东平县',
        '150905':'新泰市',
        '150906':'肥城市',
        '151001':'环翠区',
        '151002':'文登区',
        '151003':'荣成市',
        '151004':'乳山市',
        '151101':'东港区',
        '151102':'岚山区',
        '151103':'五莲县',
        '151104':'莒县',
        '151201':'莱城区',
        '151202':'钢城区',
        '151301':'兰山区',
        '151302':'罗庄区',
        '151304':'沂南县',
        '151305':'郯城县',
        '151306':'沂水县',
        '151308':'费县',
        '151309':'平邑县',
        '151310':'莒南县',
        '151311':'蒙阴县',
        '151312':'临沭县',
        '151313':'河东区',
        '151314':'兰陵县',
        '151401':'德城区',
        '151403':'宁津县',
        '151404':'庆云县',
        '151405':'临邑县',
        '151406':'齐河县',
        '151407':'平原县',
        '151408':'夏津县',
        '151409':'武城县',
        '151410':'乐陵市',
        '151411':'禹城市',
        '151412':'陵城区',
        '151501':'东昌府区',
        '151502':'阳谷县',
        '151503':'莘县',
        '151504':'茌平县',
        '151505':'东阿县',
        '151506':'冠县',
        '151507':'高唐县',
        '151508':'临清市',
        '151601':'滨城区',
        '151602':'惠民县',
        '151603':'阳信县',
        '151604':'无棣县',
        '151605':'沾化区',
        '151606':'博兴县',
        '151607':'邹平县',
        '151701':'牡丹区',
        '151702':'曹县',
        '151703':'单县',
        '151704':'成武县',
        '151705':'巨野县',
        '151706':'郓城县',
        '151707':'鄄城县',
        '151708':'定陶区',
        '151709':'东明县',
        '160101':'中原区',
        '160102':'二七区',
        '160103':'管城回族区',
        '160104':'金水区',
        '160105':'上街区',
        '160106':'惠济区',
        '160107':'中牟县',
        '160108':'巩义市',
        '160109':'荥阳市',
        '160110':'新密市',
        '160111':'新郑市',
        '160112':'登封市',
        '160201':'龙亭区',
        '160202':'顺河回族区',
        '160204':'禹王台区',
        '160206':'杞县',
        '160207':'通许县',
        '160208':'尉氏县',
        '160210':'兰考县',
        '160211':'鼓楼区',
        '160212':'祥符区',
        '160301':'老城区',
        '160302':'西工区',
        '160304':'涧西区',
        '160305':'吉利区',
        '160306':'洛龙区',
        '160307':'孟津县',
        '160308':'新安县',
        '160309':'栾川县',
        '160310':'嵩县',
        '160311':'汝阳县',
        '160312':'宜阳县',
        '160313':'洛宁县',
        '160314':'伊川县',
        '160315':'偃师市',
        '160316':'瀍河回族区',
        '160402':'卫东区',
        '160403':'石龙区',
        '160404':'湛河区',
        '160405':'宝丰县',
        '160406':'叶县',
        '160407':'鲁山县',
        '160408':'郏县',
        '160409':'舞钢市',
        '160410':'汝州市',
        '160411':'新华区',
        '160501':'文峰区',
        '160502':'北关区',
        '160503':'殷都区',
        '160504':'龙安区',
        '160505':'安阳县',
        '160506':'汤阴县',
        '160507':'滑县',
        '160508':'内黄县',
        '160509':'林州市',
        '160601':'鹤山区',
        '160602':'山城区',
        '160603':'淇滨区',
        '160604':'浚县',
        '160605':'淇县',
        '160701':'红旗区',
        '160702':'新乡县',
        '160703':'获嘉县',
        '160704':'原阳县',
        '160705':'延津县',
        '160706':'封丘县',
        '160707':'长垣县',
        '160708':'卫辉市',
        '160709':'辉县市',
        '160710':'卫滨区',
        '160711':'凤泉区',
        '160712':'牧野区',
        '160801':'解放区',
        '160802':'中站区',
        '160803':'马村区',
        '160804':'山阳区',
        '160805':'修武县',
        '160806':'博爱县',
        '160807':'武陟县',
        '160808':'温县',
        '160809':'沁阳市',
        '160810':'孟州市',
        '160901':'清丰县',
        '160902':'南乐县',
        '160903':'范县',
        '160904':'台前县',
        '160905':'濮阳县',
        '160906':'华龙区',
        '161001':'魏都区',
        '161002':'许昌县',
        '161003':'鄢陵县',
        '161004':'襄城县',
        '161005':'禹州市',
        '161006':'长葛市',
        '161007':'建安区',
        '161101':'源汇区',
        '161102':'郾城区',
        '161103':'召陵区',
        '161104':'舞阳县',
        '161105':'临颍县',
        '161201':'湖滨区',
        '161202':'渑池县',
        '161204':'卢氏县',
        '161205':'义马市',
        '161206':'灵宝市',
        '161207':'陕州区',
        '161301':'宛城区',
        '161302':'卧龙区',
        '161303':'南召县',
        '161304':'方城县',
        '161305':'西峡县',
        '161306':'镇平县',
        '161307':'内乡县',
        '161308':'淅川县',
        '161309':'社旗县',
        '161310':'唐河县',
        '161311':'新野县',
        '161312':'桐柏县',
        '161313':'邓州市',
        '161401':'梁园区',
        '161402':'睢阳区',
        '161403':'民权县',
        '161404':'睢县',
        '161405':'宁陵县',
        '161406':'柘城县',
        '161407':'虞城县',
        '161408':'夏邑县',
        '161409':'永城市',
        '161502':'平桥区',
        '161503':'罗山县',
        '161504':'光山县',
        '161505':'新县',
        '161506':'商城县',
        '161507':'固始县',
        '161508':'潢川县',
        '161509':'淮滨县',
        '161510':'息县',
        '161511':'浉河区',
        '161601':'川汇区',
        '161602':'扶沟县',
        '161603':'西华县',
        '161604':'商水县',
        '161605':'沈丘县',
        '161606':'郸城县',
        '161607':'淮阳县',
        '161608':'太康县',
        '161609':'鹿邑县',
        '161610':'项城市',
        '161701':'驿城区',
        '161702':'西平县',
        '161703':'上蔡县',
        '161704':'平舆县',
        '161705':'正阳县',
        '161706':'确山县',
        '161707':'泌阳县',
        '161708':'汝南县',
        '161709':'遂平县',
        '161710':'新蔡县',
        '161801':'济源市沁园街道',
        '161802':'济源市济水街道',
        '161803':'济源市北海街道',
        '161804':'济源市天坛街道',
        '161805':'济源市玉泉街道',
        '161806':'济源市克井镇',
        '161807':'济源市五龙口镇',
        '161808':'济源市轵城镇',
        '161809':'济源市承留镇',
        '161810':'济源市邵原镇',
        '161811':'济源市坡头镇',
        '161812':'济源市梨林镇',
        '161813':'济源市大峪镇',
        '161814':'济源市思礼镇',
        '161815':'济源市王屋镇',
        '161816':'济源市下冶镇',
        '170101':'江岸区',
        '170102':'江汉区',
        '170103':'硚口区',
        '170104':'汉阳区',
        '170105':'武昌区',
        '170107':'洪山区',
        '170108':'东西湖区',
        '170109':'汉南区',
        '170110':'蔡甸区',
        '170111':'江夏区',
        '170112':'黄陂区',
        '170113':'新洲区',
        '170114':'青山区',
        '170201':'黄石港区',
        '170202':'下陆区',
        '170203':'铁山区',
        '170204':'阳新县',
        '170205':'大冶市',
        '170206':'西塞山区',
        '170301':'茅箭区',
        '170302':'张湾区',
        '170304':'郧西县',
        '170305':'竹山县',
        '170306':'竹溪县',
        '170307':'房县',
        '170308':'丹江口市',
        '170309':'郧阳区',
        '170401':'西陵区',
        '170402':'伍家岗区',
        '170403':'点军区',
        '170404':'猇亭区',
        '170405':'夷陵区',
        '170406':'远安县',
        '170407':'兴山县',
        '170408':'秭归县',
        '170409':'长阳土家族自治县',
        '170410':'五峰土家族自治县',
        '170411':'宜都市',
        '170412':'当阳市',
        '170413':'枝江市',
        '170510':'襄城区',
        '170511':'樊城区',
        '170512':'襄州区',
        '170513':'南漳县',
        '170514':'谷城县',
        '170515':'保康县',
        '170516':'老河口市',
        '170517':'枣阳市',
        '170518':'宜城市',
        '170601':'梁子湖区',
        '170602':'华容区',
        '170603':'鄂城区',
        '170701':'东宝区',
        '170702':'掇刀区',
        '170703':'京山县',
        '170704':'沙洋县',
        '170705':'钟祥市',
        '170801':'孝南区',
        '170802':'孝昌县',
        '170803':'大悟县',
        '170804':'云梦县',
        '170805':'应城市',
        '170806':'安陆市',
        '170807':'汉川市',
        '170901':'沙市区',
        '170902':'荆州区',
        '170903':'公安县',
        '170904':'监利县',
        '170905':'江陵县',
        '170906':'石首市',
        '170907':'洪湖市',
        '170908':'松滋市',
        '171001':'黄州区',
        '171002':'团风县',
        '171003':'红安县',
        '171004':'罗田县',
        '171005':'英山县',
        '171006':'浠水县',
        '171007':'蕲春县',
        '171008':'黄梅县',
        '171009':'麻城市',
        '171010':'武穴市',
        '171101':'咸安区',
        '171102':'嘉鱼县',
        '171103':'通城县',
        '171104':'崇阳县',
        '171105':'通山县',
        '171106':'赤壁市',
        '171201':'曾都区',
        '171202':'广水市',
        '171203':'随县',
        '171301':'恩施市',
        '171302':'利川市',
        '171303':'建始县',
        '171304':'巴东县',
        '171305':'宣恩县',
        '171306':'咸丰县',
        '171307':'来凤县',
        '171308':'鹤峰县',
        '171501':'畜禽良种场',
        '171502':'工业园区',
        '171503':'豆河镇',
        '171504':'沙湖镇',
        '171505':'通海口镇',
        '171506':'胡场镇',
        '171507':'长倘口镇',
        '171508':'五湖渔场',
        '171509':'干河街道',
        '171510':'杨林尾镇',
        '171511':'西流河镇',
        '171512':'赵西垸林场',
        '171513':'九合垸原种场',
        '171514':'彭场镇',
        '171515':'沔城回族镇',
        '171516':'龙华山街道',
        '171517':'沙湖原种场',
        '171518':'陈场镇',
        '171519':'郑场镇',
        '171520':'郭河镇',
        '171521':'排湖风景区',
        '171522':'沙嘴街道',
        '171523':'毛嘴镇',
        '171524':'张沟镇',
        '171525':'三伏潭镇',
        '171601':'积玉口镇',
        '171602':'泰丰街道',
        '171603':'广华街道',
        '171604':'周矶管理区',
        '171605':'潜江经济开发区',
        '171606':'高场街道',
        '171607':'周矶街道',
        '171608':'总口管理区',
        '171609':'运粮湖管理区',
        '171610':'王场镇',
        '171611':'园林街道',
        '171612':'白鹭湖管理区',
        '171613':'竹根滩镇',
        '171614':'渔洋镇',
        '171615':'熊口镇',
        '171616':'熊口管理区',
        '171617':'后湖管理区',
        '171618':'江汉石油管理局',
        '171619':'张金镇',
        '171620':'杨市街道',
        '171621':'老新镇',
        '171622':'龙湾镇',
        '171623':'浩口原种场',
        '171624':'浩口镇',
        '171625':'高石碑镇',
        '171701':'胡市镇',
        '171702':'黄潭镇',
        '171703':'多祥镇',
        '171704':'沉湖管委会',
        '171705':'干驿镇',
        '171706':'横林镇',
        '171707':'马湾镇',
        '171708':'蒋湖农场',
        '171709':'小板镇',
        '171710':'岳口镇',
        '171711':'多宝镇',
        '171712':'蒋场镇',
        '171713':'石河镇',
        '171714':'彭市镇',
        '171715':'佛子山镇',
        '171716':'九真镇',
        '171717':'竟陵街道',
        '171718':'侨乡街道开发区',
        '171719':'麻洋镇',
        '171720':'杨林街道',
        '171721':'汪场镇',
        '171722':'白茅湖农场',
        '171723':'张港镇',
        '171724':'渔薪镇',
        '171725':'皂市镇',
        '171726':'拖市镇',
        '171727':'净潭乡',
        '171728':'卢市镇',
        '171801':'木鱼镇',
        '171802':'下谷坪土家族乡',
        '171803':'新华镇',
        '171804':'九湖镇',
        '171805':'宋洛乡',
        '171806':'松柏镇',
        '171807':'红坪镇',
        '171808':'阳日镇',
        '180101':'芙蓉区',
        '180102':'天心区',
        '180103':'岳麓区',
        '180104':'开福区',
        '180105':'雨花区',
        '180106':'长沙县',
        '180107':'望城区',
        '180108':'宁乡市',
        '180109':'浏阳市',
        '180201':'荷塘区',
        '180202':'芦淞区',
        '180203':'石峰区',
        '180204':'天元区',
        '180205':'株洲县',
        '180206':'攸县',
        '180207':'茶陵县',
        '180208':'炎陵县',
        '180209':'醴陵市',
        '180301':'雨湖区',
        '180302':'岳塘区',
        '180303':'湘潭县',
        '180304':'湘乡市',
        '180305':'韶山市',
        '180401':'珠晖区',
        '180402':'雁峰区',
        '180403':'石鼓区',
        '180404':'蒸湘区',
        '180405':'南岳区',
        '180406':'衡阳县',
        '180407':'衡南县',
        '180408':'衡山县',
        '180409':'衡东县',
        '180410':'祁东县',
        '180411':'耒阳市',
        '180412':'常宁市',
        '180501':'双清区',
        '180502':'大祥区',
        '180503':'北塔区',
        '180504':'邵东县',
        '180505':'新邵县',
        '180506':'邵阳县',
        '180507':'隆回县',
        '180508':'洞口县',
        '180509':'绥宁县',
        '180510':'新宁县',
        '180511':'城步苗族自治县',
        '180512':'武冈市',
        '180601':'岳阳楼区',
        '180602':'云溪区',
        '180603':'君山区',
        '180604':'岳阳县',
        '180605':'华容县',
        '180606':'湘阴县',
        '180607':'平江县',
        '180608':'汨罗市',
        '180609':'临湘市',
        '180701':'武陵区',
        '180702':'鼎城区',
        '180703':'安乡县',
        '180704':'汉寿县',
        '180705':'澧县',
        '180706':'临澧县',
        '180707':'桃源县',
        '180708':'石门县',
        '180709':'津市市',
        '180801':'永定区',
        '180802':'武陵源区',
        '180803':'慈利县',
        '180804':'桑植县',
        '180901':'资阳区',
        '180902':'赫山区',
        '180903':'南县',
        '180904':'桃江县',
        '180905':'安化县',
        '180906':'沅江市',
        '181001':'北湖区',
        '181002':'苏仙区',
        '181003':'桂阳县',
        '181004':'宜章县',
        '181005':'永兴县',
        '181006':'嘉禾县',
        '181007':'临武县',
        '181008':'汝城县',
        '181009':'桂东县',
        '181010':'安仁县',
        '181011':'资兴市',
        '181101':'零陵区',
        '181102':'冷水滩区',
        '181103':'祁阳县',
        '181104':'东安县',
        '181105':'双牌县',
        '181106':'道县',
        '181107':'江永县',
        '181108':'宁远县',
        '181109':'蓝山县',
        '181110':'新田县',
        '181111':'江华瑶族自治县',
        '181201':'鹤城区',
        '181202':'中方县',
        '181203':'沅陵县',
        '181204':'辰溪县',
        '181205':'溆浦县',
        '181206':'会同县',
        '181207':'麻阳苗族自治县',
        '181208':'新晃侗族自治县',
        '181209':'芷江侗族自治县',
        '181210':'靖州苗族侗族自治县',
        '181211':'通道侗族自治县',
        '181212':'洪江市',
        '181301':'娄星区',
        '181302':'双峰县',
        '181303':'新化县',
        '181304':'冷水江市',
        '181305':'涟源市',
        '181401':'吉首市',
        '181402':'泸溪县',
        '181403':'凤凰县',
        '181404':'花垣县',
        '181405':'保靖县',
        '181406':'古丈县',
        '181407':'永顺县',
        '181408':'龙山县',
        '190101':'荔湾区',
        '190102':'越秀区',
        '190103':'海珠区',
        '190104':'天河区',
        '190106':'黄埔区',
        '190107':'番禺区',
        '190108':'花都区',
        '190109':'南沙区',
        '190111':'增城区',
        '190112':'从化区',
        '190113':'白云区',
        '190201':'武江区',
        '190202':'浈江区',
        '190203':'曲江区',
        '190204':'始兴县',
        '190205':'仁化县',
        '190206':'翁源县',
        '190207':'乳源瑶族自治县',
        '190208':'新丰县',
        '190209':'乐昌市',
        '190210':'南雄市',
        '190301':'罗湖区',
        '190302':'福田区',
        '190304':'宝安区',
        '190305':'龙岗区',
        '190306':'盐田区',
        '190307':'南山区',
        '190308':'坪山新区',
        '190309':'坪山区',
        '190401':'香洲区',
        '190402':'斗门区',
        '190403':'金湾区',
        '190501':'龙湖区',
        '190502':'金平区',
        '190503':'濠江区',
        '190504':'潮阳区',
        '190505':'潮南区',
        '190506':'澄海区',
        '190507':'南澳县',
        '190601':'禅城区',
        '190602':'南海区',
        '190603':'顺德区',
        '190604':'三水区',
        '190605':'高明区',
        '190701':'蓬江区',
        '190702':'江海区',
        '190703':'新会区',
        '190704':'台山市',
        '190705':'开平市',
        '190706':'鹤山市',
        '190707':'恩平市',
        '190801':'赤坎区',
        '190802':'霞山区',
        '190803':'坡头区',
        '190804':'麻章区',
        '190805':'遂溪县',
        '190806':'徐闻县',
        '190807':'廉江市',
        '190808':'雷州市',
        '190809':'吴川市',
        '190901':'茂南区',
        '190903':'电白区',
        '190904':'高州市',
        '190905':'化州市',
        '190906':'信宜市',
        '191001':'端州区',
        '191002':'鼎湖区',
        '191003':'广宁县',
        '191004':'怀集县',
        '191005':'封开县',
        '191006':'德庆县',
        '191007':'高要区',
        '191008':'四会市',
        '191101':'惠城区',
        '191102':'惠阳区',
        '191103':'博罗县',
        '191104':'惠东县',
        '191105':'龙门县',
        '191201':'梅江区',
        '191202':'梅县区',
        '191203':'大埔县',
        '191204':'丰顺县',
        '191205':'五华县',
        '191206':'平远县',
        '191207':'蕉岭县',
        '191208':'兴宁市',
        '191302':'海丰县',
        '191303':'陆河县',
        '191304':'陆丰市',
        '191305':'城区',
        '191401':'源城区',
        '191402':'紫金县',
        '191403':'龙川县',
        '191404':'连平县',
        '191405':'和平县',
        '191406':'东源县',
        '191501':'江城区',
        '191502':'阳西县',
        '191503':'阳东区',
        '191504':'阳春市',
        '191601':'清城区',
        '191602':'佛冈县',
        '191603':'阳山县',
        '191604':'连山壮族瑶族自治县',
        '191605':'连南瑶族自治县',
        '191606':'清新区',
        '191607':'英德市',
        '191608':'连州市',
        '191701':'湘桥区',
        '191702':'潮安区',
        '191703':'饶平县',
        '191801':'榕城区',
        '191802':'揭东区',
        '191803':'揭西县',
        '191804':'惠来县',
        '191805':'普宁市',
        '191901':'云城区',
        '191902':'新兴县',
        '191903':'郁南县',
        '191904':'云安区',
        '191905':'罗定市',
        '192002':'东城街道',
        '192003':'南城街道',
        '192004':'万江街道',
        '192005':'莞城街道',
        '192006':'石碣镇',
        '192007':'石龙镇',
        '192008':'茶山镇',
        '192009':'石排镇',
        '192010':'企石镇',
        '192011':'横沥镇',
        '192012':'桥头镇',
        '192013':'谢岗镇',
        '192014':'东坑镇',
        '192015':'常平镇',
        '192016':'寮步镇',
        '192017':'樟木头镇',
        '192018':'大朗镇',
        '192019':'黄江镇',
        '192020':'清溪镇',
        '192021':'塘厦镇',
        '192022':'凤岗镇',
        '192023':'大岭山镇',
        '192024':'长安镇',
        '192025':'虎门镇',
        '192026':'厚街镇',
        '192027':'沙田镇',
        '192028':'道滘镇',
        '192029':'洪梅镇',
        '192030':'麻涌镇',
        '192031':'望牛墩镇',
        '192032':'中堂镇',
        '192033':'高埗镇',
        '192034':'松山湖管委会',
        '192035':'虎门港管委会',
        '192036':'东莞生态园',
        '192102':'石岐区街道',
        '192103':'东区街道',
        '192104':'火炬开发区街道',
        '192105':'西区街道',
        '192106':'南区街道',
        '192107':'五桂山街道',
        '192108':'小榄镇',
        '192109':'黄圃镇',
        '192110':'民众镇',
        '192111':'东凤镇',
        '192112':'东升镇',
        '192113':'古镇镇',
        '192114':'沙溪镇',
        '192115':'坦洲镇',
        '192116':'港口镇',
        '192117':'三角镇',
        '192118':'横栏镇',
        '192119':'南头镇',
        '192120':'阜沙镇',
        '192121':'南朗镇',
        '192122':'三乡镇',
        '192123':'板芙镇',
        '192124':'大涌镇',
        '192125':'神湾镇',
        '192201':'东沙群岛',
        '200101':'兴宁区',
        '200102':'青秀区',
        '200103':'江南区',
        '200104':'西乡塘区',
        '200105':'良庆区',
        '200106':'邕宁区',
        '200107':'武鸣区',
        '200108':'隆安县',
        '200109':'马山县',
        '200110':'上林县',
        '200111':'宾阳县',
        '200112':'横县',
        '200202':'鱼峰区',
        '200203':'柳南区',
        '200204':'柳北区',
        '200205':'柳江区',
        '200206':'柳城县',
        '200207':'鹿寨县',
        '200208':'融安县',
        '200209':'融水苗族自治县',
        '200210':'三江侗族自治县',
        '200211':'城中区',
        '200301':'秀峰区',
        '200302':'叠彩区',
        '200303':'象山区',
        '200304':'七星区',
        '200305':'雁山区',
        '200306':'阳朔县',
        '200307':'临桂区',
        '200308':'灵川县',
        '200309':'全州县',
        '200310':'兴安县',
        '200311':'永福县',
        '200312':'灌阳县',
        '200313':'龙胜各族自治县',
        '200314':'资源县',
        '200315':'平乐县',
        '200317':'恭城瑶族自治县',
        '200318':'荔浦县',
        '200401':'万秀区',
        '200403':'长洲区',
        '200404':'苍梧县',
        '200405':'藤县',
        '200406':'蒙山县',
        '200407':'岑溪市',
        '200408':'龙圩区',
        '200501':'海城区',
        '200502':'银海区',
        '200503':'铁山港区',
        '200504':'合浦县',
        '200601':'港口区',
        '200602':'防城区',
        '200603':'上思县',
        '200604':'东兴市',
        '200701':'钦南区',
        '200702':'钦北区',
        '200703':'灵山县',
        '200704':'浦北县',
        '200801':'港北区',
        '200802':'港南区',
        '200803':'覃塘区',
        '200804':'平南县',
        '200805':'桂平市',
        '200901':'玉州区',
        '200902':'容县',
        '200903':'陆川县',
        '200904':'博白县',
        '200905':'兴业县',
        '200906':'北流市',
        '200907':'福绵区',
        '201001':'右江区',
        '201002':'田阳县',
        '201003':'田东县',
        '201004':'平果县',
        '201005':'德保县',
        '201006':'靖西市',
        '201007':'那坡县',
        '201008':'凌云县',
        '201009':'乐业县',
        '201010':'田林县',
        '201011':'西林县',
        '201012':'隆林各族自治县',
        '201101':'八步区',
        '201102':'昭平县',
        '201103':'钟山县',
        '201104':'富川瑶族自治县',
        '201105':'平桂区',
        '201201':'金城江区',
        '201202':'南丹县',
        '201203':'天峨县',
        '201204':'凤山县',
        '201205':'东兰县',
        '201206':'罗城仫佬族自治县',
        '201207':'环江毛南族自治县',
        '201208':'巴马瑶族自治县',
        '201209':'都安瑶族自治县',
        '201210':'大化瑶族自治县',
        '201211':'宜州区',
        '201301':'兴宾区',
        '201302':'忻城县',
        '201303':'象州县',
        '201304':'武宣县',
        '201305':'金秀瑶族自治县',
        '201306':'合山市',
        '201402':'扶绥县',
        '201403':'宁明县',
        '201404':'龙州县',
        '201405':'大新县',
        '201406':'天等县',
        '201407':'凭祥市',
        '201408':'江州区',
        '210101':'秀英区',
        '210102':'龙华区',
        '210103':'琼山区',
        '210104':'美兰区',
        '210220':'海棠区',
        '210221':'吉阳区',
        '210222':'天涯区',
        '210223':'崖州区',
        '210301':'西沙群岛',
        '210302':'南沙群岛',
        '210303':'中沙群岛的岛礁及其海域',
        '210401':'洋浦经济开发区',
        '210402':'光村镇',
        '210403':'兰洋镇',
        '210404':'东成镇',
        '210405':'和庆镇',
        '210406':'国营蓝洋农场',
        '210407':'海头镇',
        '210408':'华南热作学院',
        '210409':'王五镇',
        '210410':'木棠镇',
        '210411':'新州镇',
        '210412':'中和镇',
        '210413':'排浦镇',
        '210414':'雅星镇',
        '210415':'国营西联农场',
        '210416':'国营八一农场',
        '210417':'南丰镇',
        '210418':'国营西培农场',
        '210419':'白马井镇',
        '210420':'大成镇',
        '210421':'那大镇',
        '210422':'三都镇',
        '210423':'峨蔓镇',
        '210501':'南圣镇',
        '210502':'毛阳镇',
        '210503':'国营畅好农场',
        '210504':'水满乡',
        '210505':'通什镇',
        '210506':'番阳镇',
        '210507':'畅好乡',
        '210508':'毛道乡',
        '210601':'嘉积镇',
        '210602':'会山镇',
        '210603':'国营东升农场',
        '210604':'国营东太农场',
        '210605':'万泉镇',
        '210606':'国营东红农场',
        '210607':'彬村山华侨农场',
        '210608':'大路镇',
        '210609':'潭门镇',
        '210610':'塔洋镇',
        '210611':'龙江镇',
        '210612':'石壁镇',
        '210613':'中原镇',
        '210614':'博鳌镇',
        '210615':'阳江镇',
        '210616':'长坡镇',
        '210701':'东阁镇',
        '210702':'国营罗豆农场',
        '210703':'文教镇',
        '210704':'会文镇',
        '210705':'国营东路农场',
        '210706':'铺前镇',
        '210707':'锦山镇',
        '210708':'东郊镇',
        '210709':'翁田镇',
        '210710':'龙楼镇',
        '210711':'冯坡镇',
        '210712':'国营南阳农场',
        '210713':'昌洒镇',
        '210714':'公坡镇',
        '210715':'抱罗镇',
        '210716':'东路镇',
        '210717':'潭牛镇',
        '210718':'文城镇',
        '210719':'蓬莱镇',
        '210720':'重兴镇',
        '210801':'礼纪镇',
        '210802':'国营东和农场',
        '210803':'后安镇',
        '210804':'万城镇',
        '210805':'国营东兴农场',
        '210806':'山根镇',
        '210807':'大茂镇',
        '210808':'龙滚镇',
        '210809':'和乐镇',
        '210810':'兴隆华侨农场',
        '210811':'三更罗镇',
        '210812':'长丰镇',
        '210813':'国营新中农场',
        '210814':'地方国营六连林场',
        '210815':'北大镇',
        '210816':'南桥镇',
        '210817':'东澳镇',
        '210901':'东方华侨农场',
        '210902':'江边乡',
        '210903':'东河镇',
        '210904':'新龙镇',
        '210905':'天安乡',
        '210906':'国营广坝农场',
        '210907':'感城镇',
        '210908':'三家镇',
        '210909':'四更镇',
        '210910':'板桥镇',
        '210911':'八所镇',
        '210912':'大田镇',
        '211001':'黄竹镇',
        '211002':'新竹镇',
        '211003':'国营中瑞农场',
        '211004':'富文镇',
        '211005':'定城镇',
        '211006':'岭口镇',
        '211007':'雷鸣镇',
        '211008':'国营南海农场',
        '211009':'翰林镇',
        '211010':'龙门镇',
        '211011':'国营金鸡岭农场',
        '211012':'龙河镇',
        '211013':'龙湖镇',
        '211101':'国营中建农场',
        '211102':'屯城镇',
        '211103':'新兴镇',
        '211104':'南吕镇',
        '211105':'坡心镇',
        '211106':'国营中坤农场',
        '211107':'西昌镇',
        '211108':'枫木镇',
        '211109':'南坤镇',
        '211110':'乌坡镇',
        '211201':'福山镇',
        '211202':'永发镇',
        '211203':'桥头镇',
        '211204':'金江镇',
        '211205':'中兴镇',
        '211206':'文儒镇',
        '211207':'老城镇',
        '211208':'国营红岗农场',
        '211209':'瑞溪镇',
        '211210':'国营红光农场',
        '211211':'大丰镇',
        '211212':'加乐镇',
        '211213':'仁兴镇',
        '211214':'国营金安农场',
        '211215':'国营西达农场',
        '211216':'国营昆仑农场',
        '211217':'国营和岭农场',
        '211301':'博厚镇',
        '211302':'南宝镇',
        '211303':'和舍镇',
        '211304':'调楼镇',
        '211305':'东英镇',
        '211306':'波莲镇',
        '211307':'多文镇',
        '211308':'国营加来农场',
        '211309':'新盈镇',
        '211310':'临城镇',
        '211311':'国营红华农场',
        '211312':'皇桐镇',
        '211401':'七坊镇',
        '211402':'金波乡',
        '211403':'南开乡',
        '211404':'荣邦乡',
        '211405':'邦溪镇',
        '211406':'青松乡',
        '211407':'国营龙江农场',
        '211408':'细水乡',
        '211409':'元门乡',
        '211410':'牙叉镇',
        '211411':'国营白沙农场',
        '211412':'打安镇',
        '211413':'阜龙乡',
        '211414':'国营邦溪农场',
        '211501':'十月田镇',
        '211502':'国营霸王岭林场',
        '211503':'乌烈镇',
        '211504':'七叉镇',
        '211505':'海南矿业联合有限公司',
        '211506':'叉河镇',
        '211507':'石碌镇',
        '211508':'海尾镇',
        '211509':'国营红林农场',
        '211510':'昌化镇',
        '211511':'王下乡',
        '211601':'国营山荣农场',
        '211602':'莺歌海镇',
        '211603':'国营保国农场',
        '211604':'万冲镇',
        '211605':'利国镇',
        '211606':'抱由镇',
        '211607':'国营乐光农场',
        '211608':'大安镇',
        '211609':'九所镇',
        '211610':'佛罗镇',
        '211611':'国营莺歌海盐场',
        '211612':'黄流镇',
        '211613':'国营尖峰岭林业公司',
        '211614':'志仲镇',
        '211615':'尖峰镇',
        '211616':'千家镇',
        '211701':'椰林镇',
        '211702':'黎安镇',
        '211703':'新村镇',
        '211704':'文罗镇',
        '211705':'国营吊罗山林业公司',
        '211706':'国营南平农场',
        '211707':'本号镇',
        '211708':'光坡镇',
        '211709':'群英乡',
        '211710':'提蒙乡',
        '211711':'三才镇',
        '211712':'隆广镇',
        '211713':'国营岭门农场',
        '211714':'英州镇',
        '211801':'海南保亭热带作物研究所',
        '211802':'新政镇',
        '211803':'加茂镇',
        '211804':'国营金江农场',
        '211805':'国营新星农场',
        '211806':'保城镇',
        '211807':'南林乡',
        '211808':'国营三道农场',
        '211809':'毛感乡',
        '211810':'什玲镇',
        '211811':'响水镇',
        '211812':'六弓乡',
        '211813':'三道镇',
        '211901':'吊罗山乡',
        '211902':'什运乡',
        '211903':'和平镇',
        '211904':'湾岭镇',
        '211905':'国营加钗农场',
        '211906':'国营乌石农场',
        '211907':'国营阳江农场',
        '211908':'营根镇',
        '211909':'上安乡',
        '211910':'国营黎母山林业公司',
        '211911':'中平镇',
        '211912':'国营长征农场',
        '211913':'黎母山镇',
        '211914':'长征镇',
        '211915':'红毛镇',
        '222201':'万州区',
        '222202':'涪陵区',
        '222203':'渝中区',
        '222204':'大渡口区',
        '222205':'江北区',
        '222206':'沙坪坝区',
        '222207':'九龙坡区',
        '222208':'南岸区',
        '222209':'北碚区',
        '222212':'渝北区',
        '222213':'巴南区',
        '222214':'黔江区',
        '222215':'长寿区',
        '222216':'江津区',
        '222217':'合川区',
        '222218':'永川区',
        '222219':'南川区',
        '222220':'綦江区',
        '222222':'铜梁区',
        '222223':'大足区',
        '222225':'璧山区',
        '222301':'潼南区',
        '222302':'荣昌区',
        '222303':'梁平区',
        '222304':'城口县',
        '222305':'丰都县',
        '222306':'垫江县',
        '222307':'武隆区',
        '222308':'忠县',
        '222309':'开州区',
        '222310':'云阳县',
        '222311':'奉节县',
        '222312':'巫山县',
        '222313':'巫溪县',
        '222314':'石柱土家族自治县',
        '222315':'秀山土家族苗族自治县',
        '222316':'酉阳土家族苗族自治县',
        '222317':'彭水苗族土家族自治县',
        '230101':'锦江区',
        '230102':'青羊区',
        '230103':'金牛区',
        '230104':'武侯区',
        '230105':'成华区',
        '230106':'龙泉驿区',
        '230107':'青白江区',
        '230108':'新都区',
        '230109':'金堂县',
        '230110':'双流区',
        '230111':'温江区',
        '230112':'郫都区',
        '230113':'大邑县',
        '230114':'蒲江县',
        '230115':'新津县',
        '230116':'都江堰市',
        '230117':'彭州市',
        '230118':'邛崃市',
        '230119':'崇州市',
        '230201':'自流井区',
        '230202':'贡井区',
        '230203':'大安区',
        '230204':'沿滩区',
        '230205':'荣县',
        '230206':'富顺县',
        '230302':'西区',
        '230303':'仁和区',
        '230304':'米易县',
        '230305':'盐边县',
        '230306':'东区',
        '230401':'江阳区',
        '230402':'纳溪区',
        '230403':'龙马潭区',
        '230404':'泸县',
        '230405':'合江县',
        '230406':'叙永县',
        '230407':'古蔺县',
        '230501':'旌阳区',
        '230502':'中江县',
        '230503':'罗江区',
        '230504':'广汉市',
        '230505':'什邡市',
        '230506':'绵竹市',
        '230601':'涪城区',
        '230602':'游仙区',
        '230603':'三台县',
        '230604':'盐亭县',
        '230605':'安州区',
        '230606':'梓潼县',
        '230607':'平武县',
        '230608':'江油市',
        '230609':'北川羌族自治县',
        '230701':'利州区',
        '230703':'朝天区',
        '230704':'旺苍县',
        '230705':'青川县',
        '230706':'剑阁县',
        '230707':'苍溪县',
        '230708':'昭化区',
        '230801':'船山区',
        '230802':'安居区',
        '230803':'蓬溪县',
        '230804':'射洪县',
        '230805':'大英县',
        '230902':'东兴区',
        '230903':'威远县',
        '230904':'资中县',
        '230905':'隆昌市',
        '230906':'市中区',
        '231002':'沙湾区',
        '231003':'五通桥区',
        '231004':'金口河区',
        '231005':'犍为县',
        '231006':'井研县',
        '231007':'夹江县',
        '231008':'沐川县',
        '231009':'峨边彝族自治县',
        '231010':'马边彝族自治县',
        '231011':'峨眉山市',
        '231012':'市中区',
        '231101':'顺庆区',
        '231102':'高坪区',
        '231103':'嘉陵区',
        '231104':'南部县',
        '231105':'营山县',
        '231106':'蓬安县',
        '231107':'仪陇县',
        '231108':'西充县',
        '231109':'阆中市',
        '231201':'东坡区',
        '231202':'仁寿县',
        '231203':'彭山区',
        '231204':'洪雅县',
        '231205':'丹棱县',
        '231206':'青神县',
        '231301':'翠屏区',
        '231302':'宜宾县',
        '231303':'南溪区',
        '231304':'江安县',
        '231305':'长宁县',
        '231306':'高县',
        '231307':'珙县',
        '231308':'筠连县',
        '231309':'兴文县',
        '231310':'屏山县',
        '231401':'广安区',
        '231402':'岳池县',
        '231403':'武胜县',
        '231404':'邻水县',
        '231405':'华蓥市',
        '231406':'前锋区',
        '231501':'通川区',
        '231503':'宣汉县',
        '231504':'开江县',
        '231505':'大竹县',
        '231506':'渠县',
        '231507':'万源市',
        '231508':'达川区',
        '231601':'雨城区',
        '231602':'名山区',
        '231603':'荥经县',
        '231604':'汉源县',
        '231605':'石棉县',
        '231606':'天全县',
        '231607':'芦山县',
        '231608':'宝兴县',
        '231701':'巴州区',
        '231702':'通江县',
        '231703':'南江县',
        '231704':'平昌县',
        '231705':'恩阳区',
        '231801':'雁江区',
        '231802':'安岳县',
        '231803':'乐至县',
        '231804':'简阳市',
        '231901':'汶川县',
        '231902':'理县',
        '231903':'茂县',
        '231904':'松潘县',
        '231905':'九寨沟县',
        '231906':'金川县',
        '231907':'小金县',
        '231908':'黑水县',
        '231909':'马尔康市',
        '231910':'壤塘县',
        '231911':'阿坝县',
        '231912':'若尔盖县',
        '231913':'红原县',
        '232001':'康定市',
        '232002':'泸定县',
        '232003':'丹巴县',
        '232004':'九龙县',
        '232005':'雅江县',
        '232006':'道孚县',
        '232007':'炉霍县',
        '232008':'甘孜县',
        '232009':'新龙县',
        '232010':'德格县',
        '232011':'白玉县',
        '232012':'石渠县',
        '232013':'色达县',
        '232014':'理塘县',
        '232015':'巴塘县',
        '232016':'乡城县',
        '232017':'稻城县',
        '232018':'得荣县',
        '232101':'西昌市',
        '232102':'木里藏族自治县',
        '232103':'盐源县',
        '232104':'德昌县',
        '232105':'会理县',
        '232106':'会东县',
        '232107':'宁南县',
        '232108':'普格县',
        '232109':'布拖县',
        '232110':'金阳县',
        '232111':'昭觉县',
        '232112':'喜德县',
        '232113':'冕宁县',
        '232114':'越西县',
        '232115':'甘洛县',
        '232116':'美姑县',
        '232117':'雷波县',
        '240101':'南明区',
        '240102':'云岩区',
        '240103':'花溪区',
        '240104':'乌当区',
        '240105':'贵安新区',
        '240107':'开阳县',
        '240108':'息烽县',
        '240109':'修文县',
        '240110':'清镇市',
        '240111':'白云区',
        '240112':'观山湖区',
        '240201':'钟山区',
        '240202':'六枝特区',
        '240203':'水城县',
        '240204':'盘州市',
        '240301':'红花岗区',
        '240302':'汇川区',
        '240303':'遵义县',
        '240304':'桐梓县',
        '240305':'绥阳县',
        '240306':'正安县',
        '240307':'道真仡佬族苗族自治县',
        '240308':'务川仡佬族苗族自治县',
        '240309':'凤冈县',
        '240310':'湄潭县',
        '240311':'余庆县',
        '240312':'习水县',
        '240313':'赤水市',
        '240314':'仁怀市',
        '240315':'播州区',
        '240401':'西秀区',
        '240402':'平坝区',
        '240403':'普定县',
        '240404':'镇宁布依族苗族自治县',
        '240405':'关岭布依族苗族自治县',
        '240406':'紫云苗族布依族自治县',
        '240502':'江口县',
        '240503':'玉屏侗族自治县',
        '240504':'石阡县',
        '240505':'思南县',
        '240506':'印江土家族苗族自治县',
        '240507':'德江县',
        '240508':'沿河土家族自治县',
        '240509':'松桃苗族自治县',
        '240511':'碧江区',
        '240512':'万山区',
        '240601':'兴义市',
        '240602':'兴仁县',
        '240603':'普安县',
        '240604':'晴隆县',
        '240605':'贞丰县',
        '240606':'望谟县',
        '240607':'册亨县',
        '240608':'安龙县',
        '240702':'大方县',
        '240703':'黔西县',
        '240704':'金沙县',
        '240705':'织金县',
        '240706':'纳雍县',
        '240707':'威宁彝族回族苗族自治县',
        '240708':'赫章县',
        '240709':'七星关区',
        '240801':'凯里市',
        '240802':'黄平县',
        '240803':'施秉县',
        '240804':'三穗县',
        '240805':'镇远县',
        '240806':'岑巩县',
        '240807':'天柱县',
        '240808':'锦屏县',
        '240809':'剑河县',
        '240810':'台江县',
        '240811':'黎平县',
        '240812':'榕江县',
        '240813':'从江县',
        '240814':'雷山县',
        '240815':'麻江县',
        '240816':'丹寨县',
        '240901':'都匀市',
        '240902':'福泉市',
        '240903':'荔波县',
        '240904':'贵定县',
        '240905':'瓮安县',
        '240906':'独山县',
        '240907':'平塘县',
        '240908':'罗甸县',
        '240909':'长顺县',
        '240910':'龙里县',
        '240911':'惠水县',
        '240912':'三都水族自治县',
        '250101':'五华区',
        '250102':'盘龙区',
        '250103':'官渡区',
        '250104':'西山区',
        '250105':'东川区',
        '250106':'呈贡区',
        '250107':'晋宁区',
        '250108':'富民县',
        '250109':'宜良县',
        '250110':'石林彝族自治县',
        '250111':'嵩明县',
        '250112':'禄劝彝族苗族自治县',
        '250113':'寻甸回族彝族自治县',
        '250114':'安宁市',
        '250201':'麒麟区',
        '250202':'马龙县',
        '250203':'陆良县',
        '250204':'师宗县',
        '250205':'罗平县',
        '250206':'富源县',
        '250207':'会泽县',
        '250208':'沾益区',
        '250209':'宣威市',
        '250301':'红塔区',
        '250302':'江川区',
        '250303':'澄江县',
        '250304':'通海县',
        '250305':'华宁县',
        '250306':'易门县',
        '250307':'峨山彝族自治县',
        '250308':'新平彝族傣族自治县',
        '250309':'元江哈尼族彝族傣族自治县',
        '250401':'隆阳区',
        '250402':'施甸县',
        '250403':'腾冲市',
        '250404':'龙陵县',
        '250405':'昌宁县',
        '250501':'昭阳区',
        '250502':'鲁甸县',
        '250503':'巧家县',
        '250504':'盐津县',
        '250505':'大关县',
        '250506':'永善县',
        '250507':'绥江县',
        '250508':'镇雄县',
        '250509':'彝良县',
        '250510':'威信县',
        '250511':'水富县',
        '250601':'古城区',
        '250602':'玉龙纳西族自治县',
        '250603':'永胜县',
        '250604':'华坪县',
        '250605':'宁蒗彝族自治县',
        '250701':'思茅区',
        '250702':'宁洱哈尼族彝族自治县',
        '250703':'墨江哈尼族自治县',
        '250704':'景东彝族自治县',
        '250705':'景谷傣族彝族自治县',
        '250706':'镇沅彝族哈尼族拉祜族自治县',
        '250707':'江城哈尼族彝族自治县',
        '250708':'孟连傣族拉祜族佤族自治县',
        '250709':'澜沧拉祜族自治县',
        '250710':'西盟佤族自治县',
        '250801':'临翔区',
        '250802':'凤庆县',
        '250803':'云县',
        '250804':'永德县',
        '250805':'镇康县',
        '250806':'双江拉祜族佤族布朗族傣族自治县',
        '250807':'耿马傣族佤族自治县',
        '250808':'沧源佤族自治县',
        '250901':'楚雄市',
        '250902':'双柏县',
        '250903':'牟定县',
        '250904':'南华县',
        '250905':'姚安县',
        '250906':'大姚县',
        '250907':'永仁县',
        '250908':'元谋县',
        '250909':'武定县',
        '250910':'禄丰县',
        '251001':'个旧市',
        '251002':'开远市',
        '251003':'蒙自市',
        '251004':'屏边苗族自治县',
        '251005':'建水县',
        '251006':'石屏县',
        '251007':'弥勒市',
        '251008':'泸西县',
        '251009':'元阳县',
        '251010':'红河县',
        '251011':'金平苗族瑶族傣族自治县',
        '251012':'绿春县',
        '251013':'河口瑶族自治县',
        '251101':'文山市',
        '251102':'砚山县',
        '251103':'西畴县',
        '251104':'麻栗坡县',
        '251105':'马关县',
        '251106':'丘北县',
        '251107':'广南县',
        '251108':'富宁县',
        '251201':'景洪市',
        '251202':'勐海县',
        '251203':'勐腊县',
        '251301':'大理市',
        '251302':'漾濞彝族自治县',
        '251303':'祥云县',
        '251304':'宾川县',
        '251305':'弥渡县',
        '251306':'南涧彝族自治县',
        '251307':'巍山彝族回族自治县',
        '251308':'永平县',
        '251309':'云龙县',
        '251310':'洱源县',
        '251311':'剑川县',
        '251312':'鹤庆县',
        '251401':'瑞丽市',
        '251403':'梁河县',
        '251404':'盈江县',
        '251405':'陇川县',
        '251406':'芒市',
        '251501':'泸水市',
        '251502':'福贡县',
        '251503':'贡山独龙族怒族自治县',
        '251504':'兰坪白族普米族自治县',
        '251601':'香格里拉市',
        '251602':'德钦县',
        '251603':'维西傈僳族自治县',
        '260102':'林周县',
        '260103':'当雄县',
        '260104':'尼木县',
        '260105':'曲水县',
        '260106':'堆龙德庆区',
        '260107':'达孜区',
        '260108':'墨竹工卡县',
        '260109':'城关区',
        '260202':'江达县',
        '260203':'贡觉县',
        '260204':'类乌齐县',
        '260205':'丁青县',
        '260206':'察雅县',
        '260207':'八宿县',
        '260208':'左贡县',
        '260209':'芒康县',
        '260210':'洛隆县',
        '260211':'边坝县',
        '260212':'卡若区',
        '260301':'乃东区',
        '260302':'扎囊县',
        '260303':'贡嘎县',
        '260304':'桑日县',
        '260305':'琼结县',
        '260306':'曲松县',
        '260307':'措美县',
        '260308':'洛扎县',
        '260309':'加查县',
        '260310':'隆子县',
        '260311':'错那县',
        '260312':'浪卡子县',
        '260402':'南木林县',
        '260403':'江孜县',
        '260404':'定日县',
        '260405':'萨迦县',
        '260406':'拉孜县',
        '260407':'昂仁县',
        '260408':'谢通门县',
        '260409':'白朗县',
        '260410':'仁布县',
        '260411':'康马县',
        '260412':'定结县',
        '260413':'仲巴县',
        '260414':'亚东县',
        '260415':'吉隆县',
        '260416':'聂拉木县',
        '260417':'萨嘎县',
        '260418':'岗巴县',
        '260419':'桑珠孜区',
        '260501':'色尼区',
        '260502':'嘉黎县',
        '260503':'比如县',
        '260504':'聂荣县',
        '260505':'安多县',
        '260506':'申扎县',
        '260507':'索县',
        '260508':'班戈县',
        '260509':'巴青县',
        '260510':'尼玛县',
        '260511':'双湖县',
        '260601':'普兰县',
        '260602':'札达县',
        '260603':'噶尔县',
        '260604':'日土县',
        '260605':'革吉县',
        '260606':'改则县',
        '260607':'措勤县',
        '260702':'工布江达县',
        '260703':'米林县',
        '260704':'墨脱县',
        '260705':'波密县',
        '260706':'察隅县',
        '260707':'朗县',
        '260708':'巴宜区',
        '270101':'西咸新区',
        '270102':'碑林区',
        '270103':'莲湖区',
        '270104':'灞桥区',
        '270105':'未央区',
        '270106':'雁塔区',
        '270107':'阎良区',
        '270108':'临潼区',
        '270109':'鄠邑区',
        '270110':'蓝田县',
        '270111':'周至县',
        '270112':'户县',
        '270113':'高陵区',
        '270114':'新城区',
        '270115':'长安区',
        '270201':'耀州区',
        '270202':'宜君县',
        '270203':'王益区',
        '270204':'印台区',
        '270301':'渭滨区',
        '270302':'金台区',
        '270303':'陈仓区',
        '270304':'凤翔县',
        '270305':'岐山县',
        '270306':'扶风县',
        '270307':'眉县',
        '270308':'陇县',
        '270309':'千阳县',
        '270310':'麟游县',
        '270311':'凤县',
        '270312':'太白县',
        '270401':'秦都区',
        '270402':'杨陵区',
        '270403':'渭城区',
        '270404':'三原县',
        '270405':'泾阳县',
        '270406':'乾县',
        '270407':'礼泉县',
        '270408':'永寿县',
        '270409':'彬县',
        '270410':'长武县',
        '270411':'旬邑县',
        '270412':'淳化县',
        '270413':'武功县',
        '270414':'兴平市',
        '270501':'临渭区',
        '270502':'华州区',
        '270503':'潼关县',
        '270504':'大荔县',
        '270505':'合阳县',
        '270506':'澄城县',
        '270507':'蒲城县',
        '270508':'白水县',
        '270509':'富平县',
        '270510':'韩城市',
        '270511':'华阴市',
        '270601':'宝塔区',
        '270602':'延长县',
        '270603':'延川县',
        '270604':'子长县',
        '270605':'安塞区',
        '270606':'志丹县',
        '270607':'吴起县',
        '270608':'甘泉县',
        '270609':'富县',
        '270610':'洛川县',
        '270611':'宜川县',
        '270612':'黄龙县',
        '270613':'黄陵县',
        '270701':'汉台区',
        '270702':'南郑区',
        '270703':'城固县',
        '270704':'洋县',
        '270705':'西乡县',
        '270706':'勉县',
        '270707':'宁强县',
        '270708':'略阳县',
        '270709':'镇巴县',
        '270710':'留坝县',
        '270711':'佛坪县',
        '270801':'榆阳区',
        '270802':'神木市',
        '270803':'府谷县',
        '270804':'横山区',
        '270805':'靖边县',
        '270806':'定边县',
        '270807':'绥德县',
        '270808':'米脂县',
        '270809':'佳县',
        '270810':'吴堡县',
        '270811':'清涧县',
        '270812':'子洲县',
        '270901':'汉滨区',
        '270902':'汉阴县',
        '270903':'石泉县',
        '270904':'宁陕县',
        '270905':'紫阳县',
        '270906':'岚皋县',
        '270907':'平利县',
        '270908':'镇坪县',
        '270909':'旬阳县',
        '270910':'白河县',
        '271001':'商州区',
        '271002':'洛南县',
        '271003':'丹凤县',
        '271004':'商南县',
        '271005':'山阳县',
        '271006':'镇安县',
        '271007':'柞水县',
        '280102':'七里河区',
        '280103':'西固区',
        '280104':'安宁区',
        '280105':'红古区',
        '280106':'永登县',
        '280107':'皋兰县',
        '280108':'榆中县',
        '280109':'城关区',
        '280201':'金川区',
        '280202':'永昌县',
        '280301':'白银区',
        '280302':'平川区',
        '280303':'靖远县',
        '280304':'会宁县',
        '280305':'景泰县',
        '280401':'秦州区',
        '280402':'麦积区',
        '280403':'清水县',
        '280404':'秦安县',
        '280405':'甘谷县',
        '280406':'武山县',
        '280407':'张家川回族自治县',
        '280501':'凉州区',
        '280502':'民勤县',
        '280503':'古浪县',
        '280504':'天祝藏族自治县',
        '280601':'甘州区',
        '280602':'肃南裕固族自治县',
        '280603':'民乐县',
        '280604':'临泽县',
        '280605':'高台县',
        '280606':'山丹县',
        '280701':'崆峒区',
        '280702':'泾川县',
        '280703':'灵台县',
        '280704':'崇信县',
        '280705':'华亭县',
        '280706':'庄浪县',
        '280707':'静宁县',
        '280801':'肃州区',
        '280802':'金塔县',
        '280803':'瓜州县',
        '280804':'肃北蒙古族自治县',
        '280805':'阿克塞哈萨克族自治县',
        '280806':'玉门市',
        '280807':'敦煌市',
        '280901':'西峰区',
        '280902':'庆城县',
        '280903':'环县',
        '280904':'华池县',
        '280905':'合水县',
        '280906':'正宁县',
        '280907':'宁县',
        '280908':'镇原县',
        '281001':'安定区',
        '281002':'通渭县',
        '281003':'陇西县',
        '281004':'渭源县',
        '281005':'临洮县',
        '281006':'漳县',
        '281007':'岷县',
        '281101':'武都区',
        '281102':'成县',
        '281103':'文县',
        '281104':'宕昌县',
        '281105':'康县',
        '281106':'西和县',
        '281107':'礼县',
        '281108':'徽县',
        '281109':'两当县',
        '281201':'临夏市',
        '281202':'临夏县',
        '281203':'康乐县',
        '281204':'永靖县',
        '281205':'广河县',
        '281206':'和政县',
        '281207':'东乡族自治县',
        '281208':'积石山保安族东乡族撒拉族自治县',
        '281301':'合作市',
        '281302':'临潭县',
        '281303':'卓尼县',
        '281304':'舟曲县',
        '281305':'迭部县',
        '281306':'玛曲县',
        '281307':'碌曲县',
        '281308':'夏河县',
        '281402':'新城镇',
        '281403':'峪泉镇',
        '281404':'文殊镇',
        '281405':'雄关区',
        '281406':'镜铁区',
        '281407':'长城区',
        '290101':'城东区',
        '290103':'城西区',
        '290104':'城北区',
        '290105':'大通回族土族自治县',
        '290106':'湟中县',
        '290107':'湟源县',
        '290108':'城中区',
        '290201':'平安区',
        '290202':'民和回族土族自治县',
        '290203':'乐都区',
        '290204':'互助土族自治县',
        '290205':'化隆回族自治县',
        '290206':'循化撒拉族自治县',
        '290301':'门源回族自治县',
        '290302':'祁连县',
        '290303':'海晏县',
        '290304':'刚察县',
        '290401':'同仁县',
        '290402':'尖扎县',
        '290403':'泽库县',
        '290404':'河南蒙古族自治县',
        '290506':'共和县',
        '290507':'同德县',
        '290508':'贵德县',
        '290509':'兴海县',
        '290510':'贵南县',
        '290601':'玛沁县',
        '290602':'班玛县',
        '290603':'甘德县',
        '290604':'达日县',
        '290605':'久治县',
        '290606':'玛多县',
        '290701':'玉树市',
        '290702':'杂多县',
        '290703':'称多县',
        '290704':'治多县',
        '290705':'囊谦县',
        '290706':'曲麻莱县',
        '290801':'格尔木市',
        '290802':'德令哈市',
        '290803':'乌兰县',
        '290804':'都兰县',
        '290805':'天峻县',
        '290809':'海西蒙古族藏族自治州直辖',
        '300101':'兴庆区',
        '300102':'西夏区',
        '300103':'金凤区',
        '300104':'永宁县',
        '300105':'贺兰县',
        '300106':'灵武市',
        '300201':'大武口区',
        '300202':'惠农区',
        '300203':'平罗县',
        '300301':'利通区',
        '300302':'盐池县',
        '300303':'同心县',
        '300304':'青铜峡市',
        '300305':'红寺堡区',
        '300401':'原州区',
        '300402':'西吉县',
        '300403':'隆德县',
        '300404':'泾源县',
        '300405':'彭阳县',
        '300501':'沙坡头区',
        '300502':'中宁县',
        '300503':'海原县',
        '310101':'天山区',
        '310102':'沙依巴克区',
        '310104':'水磨沟区',
        '310105':'头屯河区',
        '310106':'米东区',
        '310107':'乌鲁木齐县',
        '310108':'新市区',
        '310109':'达坂城区',
        '310201':'独山子区',
        '310202':'克拉玛依区',
        '310203':'白碱滩区',
        '310204':'乌尔禾区',
        '310302':'鄯善县',
        '310303':'托克逊县',
        '310304':'高昌区',
        '310401':'哈密市',
        '310402':'巴里坤哈萨克自治县',
        '310403':'伊吾县',
        '310404':'伊州区',
        '310501':'昌吉市',
        '310502':'阜康市',
        '310503':'呼图壁县',
        '310504':'玛纳斯县',
        '310505':'奇台县',
        '310506':'吉木萨尔县',
        '310507':'木垒哈萨克自治县',
        '310601':'博乐市',
        '310602':'精河县',
        '310603':'温泉县',
        '310604':'阿拉山口市',
        '310701':'库尔勒市',
        '310702':'轮台县',
        '310703':'尉犁县',
        '310704':'若羌县',
        '310705':'且末县',
        '310706':'焉耆回族自治县',
        '310707':'和静县',
        '310708':'和硕县',
        '310709':'博湖县',
        '310801':'阿克苏市',
        '310802':'温宿县',
        '310803':'库车县',
        '310804':'沙雅县',
        '310805':'新和县',
        '310806':'拜城县',
        '310807':'乌什县',
        '310808':'阿瓦提县',
        '310809':'柯坪县',
        '310901':'阿图什市',
        '310902':'阿克陶县',
        '310903':'阿合奇县',
        '310904':'乌恰县',
        '311001':'喀什市',
        '311002':'疏附县',
        '311003':'疏勒县',
        '311004':'英吉沙县',
        '311005':'泽普县',
        '311006':'莎车县',
        '311007':'叶城县',
        '311008':'麦盖提县',
        '311009':'岳普湖县',
        '311010':'伽师县',
        '311011':'巴楚县',
        '311012':'塔什库尔干塔吉克自治县',
        '311101':'和田市',
        '311102':'和田县',
        '311103':'墨玉县',
        '311104':'皮山县',
        '311105':'洛浦县',
        '311106':'策勒县',
        '311107':'于田县',
        '311108':'民丰县',
        '311201':'伊宁市',
        '311202':'奎屯市',
        '311203':'伊宁县',
        '311204':'察布查尔锡伯自治县',
        '311205':'霍城县',
        '311206':'巩留县',
        '311207':'新源县',
        '311208':'昭苏县',
        '311209':'特克斯县',
        '311210':'尼勒克县',
        '311211':'霍尔果斯市',
        '311301':'塔城市',
        '311302':'乌苏市',
        '311303':'额敏县',
        '311304':'沙湾县',
        '311305':'托里县',
        '311306':'裕民县',
        '311307':'和布克赛尔蒙古自治县',
        '311401':'阿勒泰市',
        '311402':'布尔津县',
        '311403':'富蕴县',
        '311404':'福海县',
        '311405':'哈巴河县',
        '311406':'青河县',
        '311407':'吉木乃县',
        '311601':'兵团一五二团',
        '311602':'向阳街道',
        '311603':'红山街道',
        '311604':'东城街道',
        '311605':'石河子乡',
        '311606':'老街街道',
        '311607':'新城街道',
        '311608':'北泉镇',
        '311701':'幸福路街道',
        '311702':'阿拉尔农场',
        '311703':'兵团第一师幸福农场',
        '311704':'工业园区',
        '311705':'兵团七团',
        '311706':'兵团十一团',
        '311707':'青松路街道',
        '311708':'托喀依乡',
        '311709':'兵团第一师水利水电工程处',
        '311710':'兵团八团',
        '311711':'中心监狱',
        '311712':'兵团第一师塔里木灌区水利管理处',
        '311713':'兵团十四团',
        '311714':'兵团十六团',
        '311715':'兵团十二团',
        '311716':'金银川路街道',
        '311717':'兵团十团',
        '311718':'兵团十三团',
        '311719':'南口街道',
        '311801':'兵团四十九团',
        '311802':'兵团图木舒克市永安坝',
        '311803':'兵团五十一团',
        '311804':'前海街道',
        '311805':'兵团图木舒克市喀拉拜勒镇',
        '311806':'永安坝街道',
        '311807':'齐干却勒街道',
        '311808':'兵团五十三团',
        '311809':'兵团五十团',
        '311810':'兵团四十四团',
        '311901':'兵团一零二团',
        '311902':'军垦路街道',
        '311903':'人民路街道',
        '311904':'兵团一零一团',
        '311905':'兵团一零三团',
        '311906':'青湖路街道',
        '312001':'兵团一八七团',
        '312002':'北屯镇',
        '312003':'兵团一八八团',
        '312004':'兵团一八三团',
        '312101':'兵团二十九团',
        '312102':'农二师三十团',
        '312201':'兵团八十九团',
        '312202':'兵团八十六团',
        '312203':'兵团八十四团',
        '312204':'兵团九十团',
        '312205':'兵团八十一团',
        '312301':'兵团六十八团',
        '312302':'都拉塔口岸',
        '312303':'兵团六十七团',
        '312304':'兵团六十六团',
        '312305':'兵团六十三团',
        '312306':'兵团六十四团',
        '335211':'九龙城区',
        '335212':'油尖旺区',
        '335213':'深水埗区',
        '335214':'观塘区',
        '335215':'黄大仙区',
        '335216':'元朗区',
        '335217':'北区',
        '335218':'大埔区',
        '335219':'屯门区',
        '335220':'沙田区',
        '335221':'荃湾区',
        '335222':'葵青区',
        '335223':'西贡区',
        '335224':'中西区',
        '335225':'南区',
        '335226':'东区',
        '335227':'湾仔区',
        '335228':'离岛区',
        '340101':'中正区',
        '340102':'大同区',
        '340103':'中山区',
        '340104':'松山区',
        '340105':'大安区',
        '340106':'万华区',
        '340107':'信义区',
        '340108':'士林区',
        '340109':'北投区',
        '340110':'内湖区',
        '340111':'南港区',
        '340112':'文山区',
        '340113':'其它区',
        '340201':'新兴区',
        '340202':'前金区',
        '340203':'芩雅区',
        '340204':'盐埕区',
        '340205':'鼓山区',
        '340206':'旗津区',
        '340207':'前镇区',
        '340208':'三民区',
        '340209':'左营区',
        '340210':'楠梓区',
        '340211':'小港区',
        '340212':'其它区',
        '340213':'苓雅区',
        '340214':'仁武区',
        '340215':'大社区',
        '340216':'冈山区',
        '340217':'路竹区',
        '340218':'阿莲区',
        '340219':'田寮区',
        '340220':'燕巢区',
        '340221':'桥头区',
        '340222':'梓官区',
        '340223':'弥陀区',
        '340224':'永安区',
        '340225':'湖内区',
        '340226':'凤山区',
        '340227':'大寮区',
        '340228':'林园区',
        '340229':'鸟松区',
        '340230':'大树区',
        '340231':'旗山区',
        '340232':'美浓区',
        '340233':'六龟区',
        '340234':'内门区',
        '340235':'杉林区',
        '340236':'甲仙区',
        '340237':'桃源区',
        '340238':'那玛夏区',
        '340239':'茂林区',
        '340240':'茄萣区',
        '340301':'中西区',
        '340302':'东区',
        '340303':'南区',
        '340304':'北区',
        '340305':'安平区',
        '340306':'安南区',
        '340307':'其它区',
        '340308':'永康区',
        '340309':'归仁区',
        '340310':'新化区',
        '340311':'左镇区',
        '340312':'玉井区',
        '340313':'楠西区',
        '340314':'南化区',
        '340315':'仁德区',
        '340316':'关庙区',
        '340317':'龙崎区',
        '340318':'官田区',
        '340319':'麻豆区',
        '340320':'佳里区',
        '340321':'西港区',
        '340322':'七股区',
        '340323':'将军区',
        '340324':'学甲区',
        '340325':'北门区',
        '340326':'新营区',
        '340327':'后壁区',
        '340328':'白河区',
        '340329':'东山区',
        '340330':'六甲区',
        '340331':'下营区',
        '340332':'柳营区',
        '340333':'盐水区',
        '340334':'善化区',
        '340335':'大内区',
        '340336':'山上区',
        '340337':'新市区',
        '340338':'安定区',
        '340401':'中区',
        '340402':'东区',
        '340403':'南区',
        '340404':'西区',
        '340405':'北区',
        '340406':'北屯区',
        '340407':'西屯区',
        '340408':'南屯区',
        '340409':'其它区',
        '340410':'太平区',
        '340411':'大里区',
        '340412':'雾峰区',
        '340413':'乌日区',
        '340414':'丰原区',
        '340415':'后里区',
        '340416':'石冈区',
        '340417':'东势区',
        '340418':'和平区',
        '340419':'新社区',
        '340420':'潭子区',
        '340421':'大雅区',
        '340422':'神冈区',
        '340423':'大肚区',
        '340424':'沙鹿区',
        '340425':'龙井区',
        '340426':'梧栖区',
        '340427':'清水区',
        '340428':'大甲区',
        '340429':'外埔区',
        '340430':'大安区',
        '340501':'金沙镇',
        '340502':'金湖镇',
        '340503':'金宁乡',
        '340504':'金城镇',
        '340505':'烈屿乡',
        '340506':'乌坵乡',
        '340601':'南投市',
        '340602':'中寮乡',
        '340603':'草屯镇',
        '340604':'国姓乡',
        '340605':'埔里镇',
        '340606':'仁爱乡',
        '340607':'名间乡',
        '340608':'集集镇',
        '340609':'水里乡',
        '340610':'鱼池乡',
        '340611':'信义乡',
        '340612':'竹山镇',
        '340613':'鹿谷乡',
        '340701':'仁爱区',
        '340702':'信义区',
        '340703':'中正区',
        '340704':'中山区',
        '340705':'安乐区',
        '340706':'暖暖区',
        '340707':'七堵区',
        '340708':'其它区',
        '340801':'东区',
        '340802':'北区',
        '340803':'香山区',
        '340804':'其它区',
        '340901':'东区',
        '340902':'西区',
        '340903':'其它区',
        '341001':'万里区',
        '341002':'金山区',
        '341003':'板桥区',
        '341004':'汐止区',
        '341005':'深坑区',
        '341006':'石碇区',
        '341007':'瑞芳区',
        '341008':'平溪区',
        '341009':'双溪区',
        '341010':'贡寮区',
        '341011':'新店区',
        '341012':'坪林区',
        '341013':'乌来区',
        '341014':'永和区',
        '341015':'中和区',
        '341016':'土城区',
        '341017':'三峡区',
        '341018':'树林区',
        '341019':'莺歌区',
        '341020':'三重区',
        '341021':'新庄区',
        '341022':'泰山区',
        '341023':'林口区',
        '341024':'芦洲区',
        '341025':'五股区',
        '341026':'八里区',
        '341027':'淡水区',
        '341028':'三芝区',
        '341029':'石门区',
        '341101':'宜兰市',
        '341102':'头城镇',
        '341103':'礁溪乡',
        '341104':'壮围乡',
        '341105':'员山乡',
        '341106':'罗东镇',
        '341107':'三星乡',
        '341108':'大同乡',
        '341109':'五结乡',
        '341110':'冬山乡',
        '341111':'苏澳镇',
        '341112':'南澳乡',
        '341113':'钓鱼台',
        '341201':'竹北市',
        '341202':'湖口乡',
        '341203':'新丰乡',
        '341204':'新埔镇',
        '341205':'关西镇',
        '341206':'芎林乡',
        '341207':'宝山乡',
        '341208':'竹东镇',
        '341209':'五峰乡',
        '341210':'横山乡',
        '341211':'尖石乡',
        '341212':'北埔乡',
        '341213':'峨眉乡',
        '341301':'中坜市',
        '341302':'平镇市',
        '341303':'龙潭乡',
        '341304':'杨梅市',
        '341305':'新屋乡',
        '341306':'观音乡',
        '341307':'桃园市',
        '341308':'龟山乡',
        '341309':'八德市',
        '341310':'大溪镇',
        '341311':'复兴乡',
        '341312':'大园乡',
        '341313':'芦竹乡',
        '341401':'竹南镇',
        '341402':'头份镇',
        '341403':'三湾乡',
        '341404':'南庄乡',
        '341405':'狮潭乡',
        '341406':'后龙镇',
        '341407':'通霄镇',
        '341408':'苑里镇',
        '341409':'苗栗市',
        '341410':'造桥乡',
        '341411':'头屋乡',
        '341412':'公馆乡',
        '341413':'大湖乡',
        '341414':'泰安乡',
        '341415':'铜锣乡',
        '341416':'三义乡',
        '341417':'西湖乡',
        '341418':'卓兰镇',
        '341501':'彰化市',
        '341502':'芬园乡',
        '341503':'花坛乡',
        '341504':'秀水乡',
        '341505':'鹿港镇',
        '341506':'福兴乡',
        '341507':'线西乡',
        '341508':'和美镇',
        '341509':'伸港乡',
        '341510':'员林镇',
        '341511':'社头乡',
        '341512':'永靖乡',
        '341513':'埔心乡',
        '341514':'溪湖镇',
        '341515':'大村乡',
        '341516':'埔盐乡',
        '341517':'田中镇',
        '341518':'北斗镇',
        '341519':'田尾乡',
        '341520':'埤头乡',
        '341521':'溪州乡',
        '341522':'竹塘乡',
        '341523':'二林镇',
        '341524':'大城乡',
        '341525':'芳苑乡',
        '341526':'二水乡',
        '341601':'番路乡',
        '341602':'梅山乡',
        '341603':'竹崎乡',
        '341604':'阿里山乡',
        '341605':'中埔乡',
        '341606':'大埔乡',
        '341607':'水上乡',
        '341608':'鹿草乡',
        '341609':'太保市',
        '341610':'朴子市',
        '341611':'东石乡',
        '341612':'六脚乡',
        '341613':'新港乡',
        '341614':'民雄乡',
        '341615':'大林镇',
        '341616':'溪口乡',
        '341617':'义竹乡',
        '341618':'布袋镇',
        '341701':'斗南镇',
        '341702':'大埤乡',
        '341703':'虎尾镇',
        '341704':'土库镇',
        '341705':'褒忠乡',
        '341706':'东势乡',
        '341707':'台西乡',
        '341708':'仑背乡',
        '341709':'麦寮乡',
        '341710':'斗六市',
        '341711':'林内乡',
        '341712':'古坑乡',
        '341713':'莿桐乡',
        '341714':'西螺镇',
        '341715':'二仑乡',
        '341716':'北港镇',
        '341717':'水林乡',
        '341718':'口湖乡',
        '341719':'四湖乡',
        '341720':'元长乡',
        '341801':'屏东市',
        '341802':'三地门乡',
        '341803':'雾台乡',
        '341804':'玛家乡',
        '341805':'九如乡',
        '341806':'里港乡',
        '341807':'高树乡',
        '341808':'盐埔乡',
        '341809':'长治乡',
        '341810':'麟洛乡',
        '341811':'竹田乡',
        '341812':'内埔乡',
        '341813':'万丹乡',
        '341814':'潮州镇',
        '341815':'泰武乡',
        '341816':'来义乡',
        '341817':'万峦乡',
        '341818':'崁顶乡',
        '341819':'新埤乡',
        '341820':'南州乡',
        '341821':'林边乡',
        '341822':'东港镇',
        '341823':'琉球乡',
        '341824':'佳冬乡',
        '341825':'新园乡',
        '341826':'枋寮乡',
        '341827':'枋山乡',
        '341828':'春日乡',
        '341829':'狮子乡',
        '341830':'车城乡',
        '341831':'牡丹乡',
        '341832':'恒春镇',
        '341833':'满州乡',
        '341901':'台东市',
        '341902':'绿岛乡',
        '341903':'兰屿乡',
        '341904':'延平乡',
        '341905':'卑南乡',
        '341906':'鹿野乡',
        '341907':'关山镇',
        '341908':'海端乡',
        '341909':'池上乡',
        '341910':'东河乡',
        '341911':'成功镇',
        '341912':'长滨乡',
        '341913':'金峰乡',
        '341914':'大武乡',
        '341915':'达仁乡',
        '341916':'太麻里乡',
        '342001':'花莲市',
        '342002':'新城乡',
        '342003':'太鲁阁',
        '342004':'秀林乡',
        '342005':'吉安乡',
        '342006':'寿丰乡',
        '342007':'凤林镇',
        '342008':'光复乡',
        '342009':'丰滨乡',
        '342010':'瑞穗乡',
        '342011':'万荣乡',
        '342012':'玉里镇',
        '342013':'卓溪乡',
        '342014':'富里乡',
        '342101':'马公市',
        '342102':'西屿乡',
        '342103':'望安乡',
        '342104':'七美乡',
        '342105':'白沙乡',
        '342106':'湖西乡',
        '342201':'南竿乡',
        '342202':'北竿乡',
        '342203':'莒光乡',
        '342204':'东引乡',
        '350101':'花地玛堂区',
        '350102':'花王堂区',
        '350103':'望德堂区',
        '350104':'大堂区',
        '350105':'风顺堂区',
        '350106':'嘉模堂区',
        '350107':'路凼填海区',
        '350108':'圣方济各堂区',
    },
};